// import React, { useRef, useState } from 'react';
// import {
//   Button,
//   Box,
//   Flex,
//   Image,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalCloseButton,
//   ModalBody,
//   ModalFooter,
//   FormControl,
//   Text,
//   SimpleGrid,
//   useColorModeValue,
//   Img,
//   Icon,
//   Spinner,
// } from '@chakra-ui/react';
// import InputField from 'components/fields/InputField';
// import Card from 'components/card/Card';

// import { MdOutlineAdd, MdOutlineCheck } from 'react-icons/md';
// import Select from 'react-select';
// import {
//   FaVolumeUp,
//   FaPlusCircle,
//   FaSlidersH,
//   FaWindowClose,
//   FaChevronLeft,
//   FaChevronRight,
// } from 'react-icons/fa';
// import { motion } from 'framer-motion';

// const customStyles = {
//   option: (provided: any, state: any) => ({
//     ...provided,
//     backgroundColor: state.isFocused ? '#e0e0e0' : 'transparent',
//     cursor: 'pointer',
//     color: 'black',
//     zIndex: '101',
//     '&:hover': {
//       backgroundColor: '#e0e0e0', // Change background color on hover
//     },
//   }),
// };

// const customStylesselect = {
//   marginRight: '20px',
//   position: 'absolute',
//   zIndex: 101,
// };
// const customStylesicon = {
//   cursor: 'pointer',
//   color: 'grey',
//   marginRight: '4px',
// };
// const customStylesBtn = {
//   padding: '0px',
//   marginBottom: '0px',
//   marginTop: '0px',
//   height: '44px',
//   borderRadius: '5px',
//   border: 'none',
//   cursor: 'pointer',
//   backgroundColor: 'transparent',
//   alignItems: 'center',
//   alignContent: 'center',
//   display: 'flex',
//   justifyContent: 'center',
// };

// const CharacterPreview: React.FC<{
//   id?: any;
//   languages?: any;
//   players?: any;
//   setPreview?: any;
//   makeInputFiled?: any;
//   onClose?: any;
//   values?: any;
//   setValues?: any;
//   previewId?: any;
//   setFormData?: any;
//   formData?: any;
//   commonNextFunction?: any;
//   voices: any;
//   show: any;
//   prev: any;
//   staticAssetImageUrls: any;
// }> = ({
//   id,
//   languages,
//   prev,
//   players,
//   setPreview,
//   makeInputFiled,
//   onClose,
//   values,
//   setValues,
//   previewId,
//   setFormData,
//   formData,
//   voices,
//   commonNextFunction,
//   show,
//   staticAssetImageUrls,
// }) => {

//   console.log(voices,'voicesincharacter')
//   const textContent =
//     'Game Content means any templates, modules, functions, features, images, audio data, video data, or other content that may be used by a Game Creator when creating a Game.';
//   const truncatedText = textContent.slice(0, 80) + '...';

//   const selectedPlayer = players.find(
//     (player: any) => player.gasId === previewId,
//   );

//   const handleNonPlayerVoice: React.ChangeEventHandler<HTMLSelectElement> = (
//     e,
//   ) => {
//     setFormData((prev: any) => ({
//       ...prev,
//       gameNonPlayerVoice: e.target.value || '',
//     }));
//   };
//   const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');
//   const textColor = useColorModeValue('secondaryGray.900', 'white');
//   const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
//   const textColorSecondary = 'secondaryGray.600';
//   const [iconColor, setIconColor] = useState('grey');
//   const handleMouseEnter = () => {
//     setIconColor('black');
//   };

//   const handleMouseLeave = () => {
//     setIconColor('grey');
//   };
//   const handlePlayerMale: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
//     setFormData((prev: any) => ({
//       ...prev,
//       gamePlayerMaleVoice: e.target.value || '',
//     }));
//   };

//   const handlePlayerFemale: React.ChangeEventHandler<HTMLSelectElement> = (
//     e,
//   ) => {
//     setFormData((prev: any) => ({
//       ...prev,
//       gamePlayerFemaleVoice: e.target.value || '',
//     }));
//   };

//   const character_Image = staticAssetImageUrls?.character_Image;
//   const full_Images = character_Image?.filter((img: any) => img?.id === 'full');
//   const half_Images = character_Image?.filter((img: any) => img?.id === 'half');

//   const find_Selected_fullimage =
//     full_Images &&
//     full_Images?.find((img: any) => img?.name == selectedPlayer?.gasAssetName);
//   const find_Selected_halfimage =
//     half_Images &&
//     half_Images?.find((img: any) => img?.name == selectedPlayer?.gasAssetName);

//   const handleNarrator: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
//     setFormData((prev: any) => ({
//       ...prev,
//       gameNarratorVoice: e.target.value || '',
//     }));
//   };

//   const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
//     setFormData((prev: any) => ({
//       ...prev,
//       gameNonPlayerName: e.target.value || '',
//     }));
//   };
//   const find = show.find((it: any) => it.gasId === formData.gameBackgroundId);
//   const img = find?.gasAssetImage;
//   //////////////////////////////////////////////////////////////////////////////
//   const [showModal, setShowModal] = useState(false);
//   const [chosenModal, setChosenModal] = useState('');
//   const [chosenVoiceNPC, setChosenVoiceNPC] = useState('');
//   const [chosenVoiceMALE, setChosenVoiceMALE] = useState('');
//   const [chosenVoiceFEMALE, setChosenVoiceFEMALE] = useState('');
//   const [chosenVoiceNAR, setChosenVoiceNAR] = useState('');
//   const handleAddVoice = (character: any) => {
//     setChosenModal(character);
//     setShowModal(true); // Show the modal when the button is clicked

//     //alert(chosenModal);
//   };
//   const closeModal = () => {
//     setShowModal(false); // Function to close the modal
//     setChosenModal('');
//   };

//   const audioRef = useRef(null);

//   const [searchTerm, setSearchTerm] = useState('');
//   const [demo, setDemo] = useState(null);
//   const handleInputChange = (inputValue: any) => {
//     setSearchTerm(inputValue);
//   };

//   let currentAudio: any = null;
//   const playAudio = (audioUrl: string): Promise<void> => {
//     return new Promise<void>((resolve) => {
//       if (currentAudio) {
//         currentAudio.pause();
//         currentAudio.removeEventListener('ended', resolve);
//       }

//       const audio = new Audio(audioUrl);

//       audio.addEventListener('ended', () => {
//         resolve();
//       });

//       audio.play();
//       currentAudio = audio;
//     });
//   };
//   const customFilter = (option: any, rawInput: any) => {
//     const inputValue = rawInput.toLowerCase();
//     const label = option.label.toLowerCase();

//     if (label.includes(inputValue)) {
//       return true;
//     }
//     if (option.data && option.data.subcategories) {
//       const subcategoryMatch = option.data.subcategories.some(
//         (subcategory: any) => subcategory.toLowerCase().includes(inputValue),
//       );
//       return subcategoryMatch;
//     }
//     return false;
//   };
//   const [menuIsOpen, setMenuIsOpen] = useState(false);

//   const handleMenuOpen = () => {
//     setMenuIsOpen(true);
//   };

//   const handleMenuClose = () => {
//     setMenuIsOpen(false);
//   };
//   const [menuMaleIsOpen, setMenuMaleIsOpen] = useState(false);

//   const handleMaleMenuOpen = () => {
//     setMenuMaleIsOpen(true);
//   };
//   const [nonplayerName, setNonplayerName] = useState<String>();

//   const handleMaleMenuClose = () => {
//     setMenuMaleIsOpen(false);
//   };
//   const [menufeMaleIsOpen, setMenufeMaleIsOpen] = useState(false);

//   const handlefeMaleMenuOpen = () => {
//     setMenufeMaleIsOpen(true);
//   };

//   const handlefeMaleMenuClose = () => {
//     setMenufeMaleIsOpen(false);
//   };
//   const [menuNarateIsOpen, setMenuNarateIsOpen] = useState(false);

//   const handleNarateMenuOpen = () => {
//     setMenuNarateIsOpen(true);
//   };

//   const handleNarateeMenuClose = () => {
//     setMenuNarateIsOpen(false);
//   };
//   const options = voices.map((it: any, ind: number) => {
//     const { age, accent, gender, ...remainingLabels } = it.labels;
//     const subcategories = Object.values(remainingLabels);
//     return {
//       label: it.name,
//       value: it.voice_id,
//       subcategories: subcategories,
//       audio: it.preview_url,
//       index: ind,
//       age: age,
//       accent: accent,
//       gender: gender,
//     };
//   });
// console.log(options,'optionsinvoices')
//   const maleOptions = voices
//     .filter((it: any) => it.labels.gender === 'male')
//     .map((it: any, ind: number) => {
//       const { gender, ...remainingLabels } = it.labels;
//       const subcategories = Object.values(remainingLabels);
//       return {
//         label: it.name,
//         value: it.voice_id,
//         subcategories: subcategories,
//         audio: it.preview_url,
//         index: ind,
//       };
//     });
//   const femaleOptions = voices
//     .filter((it: any) => it.labels.gender === 'female')
//     .map((it: any, ind: number) => {
//       const { gender, ...remainingLabels } = it.labels;
//       const subcategories = Object.values(remainingLabels);
//       return {
//         label: it.name,
//         value: it.voice_id,
//         subcategories: subcategories,
//         audio: it.preview_url,
//         index: ind,
//       };
//     });
//   const narrationOptions = voices
//     .filter((it: any) => it.labels['use case'] === 'narration')
//     .map((it: any, ind: number) => {
//       const { 'use case': useCase, ...remainingLabels } = it.labels;
//       const subcategories = Object.values(remainingLabels);
//       return {
//         label: it.name,
//         value: it.voice_id,
//         subcategories: subcategories,
//         audio: it.preview_url,
//         index: ind,
//       };
//     });

//   const handleSelectChange = (selectedOption: any, type: string) => {
//     setDemo(selectedOption?.audio);
//     if (type === 'NPC') {
//       setFormData((prev: any) => ({
//         ...prev,
//         gameNonPlayerVoice: selectedOption.value,
//       }));
//       setShowModal(false); // Function to close the modal
//       setChosenModal('');
//       setChosenVoiceNPC(selectedOption.label);
//     } else if (type === 'MALE') {
//       setFormData((prev: any) => ({
//         ...prev,
//         gamePlayerMaleVoice: selectedOption.value,
//       }));
//       setShowModal(false); // Function to close the modal
//       setChosenModal('');
//       setChosenVoiceMALE(selectedOption.label);
//     } else if (type === 'FEMALE') {
//       setFormData((prev: any) => ({
//         ...prev,
//         gamePlayerFemaleVoice: selectedOption.value,
//       }));
//       setShowModal(false); // Function to close the modal
//       setChosenModal('');
//       setChosenVoiceFEMALE(selectedOption.label);
//     } else {
//       if (type === 'NARRATOR') {
//         setFormData((prev: any) => ({
//           ...prev,
//           gameNarratorVoice: selectedOption.value,
//         }));
//         setShowModal(false); // Function to close the modal
//         setChosenModal('');
//         setChosenVoiceNAR(selectedOption.label);
//       }
//     }
//   };
//   const [selectedVoice, setSelectedVoice] = useState(null); // To keep track of the selected voice
//   const [isPlaying, setIsPlaying] = useState(false);
//   const handleClick = async (e: any, data: any) => {
//     setIsPlaying(true);
//     setSelectedVoice(data);
//     try {
//       await playAudio(data.audio);
//       setIsPlaying(false);
//     } catch (error) {
//       console.error('Error playing audio: ', error);
//       setIsPlaying(false); // Ensure isPlaying is set to false in case of an error
//     }
//   };
//   const colors = ['#e0e7ff', '#f3e8ff'];

//   const [selectedFilters, setSelectedFilters] = useState([]); // To keep track of selected filters

//   const uniqueSubcategories = [
//     ...new Set(options.map((voice: any) => voice.subcategories[1])),
//   ];
//   const uniquegender = [...new Set(options.map((voice: any) => voice.gender))];
//   const uniqueaccent = [...new Set(options.map((voice: any) => voice.accent))];
//   const uniqueage = [...new Set(options.map((voice: any) => voice.age))];
//   const handleFilterClick = (subcategory: any) => {
//     const isSubcategorySelected = selectedFilters.includes(subcategory);

//     const updatedFilters = isSubcategorySelected
//       ? selectedFilters.filter((filter) => filter !== subcategory)
//       : [...selectedFilters, subcategory];

//     // Update the selectedFilters state with the updated array
//     setSelectedFilters(updatedFilters);
//   };
//   const filteredSubcategories = uniqueSubcategories.filter(
//     (subcategory) => subcategory !== undefined,
//   );
//   const filteredgender = uniquegender.filter(
//     (subcategory) => subcategory !== undefined,
//   );
//   const filteredaccent = uniqueaccent.filter(
//     (subcategory) => subcategory !== undefined,
//   );
//   const filteredage = uniqueage.filter(
//     (subcategory) => subcategory !== undefined,
//   );
//   const [genderOptions, setGenderOptions] = useState(
//     filteredgender.map((option) => ({ label: option, value: option })),
//   );
//   const [accentOptions, setAccentOptions] = useState(
//     filteredaccent.map((option) => ({ label: option, value: option })),
//   );

//   const [ageOptions, setAgeOptions] = useState(
//     filteredage.map((option) => ({ label: option, value: option })),
//   );

//   const [searchText, setSearchText] = useState('');
//   const [selectedGender, setSelectedGender] = useState('');
//   const [selectedAccent, setSelectedAccent] = useState('');
//   const [selectedAge, setSelectedAge] = useState('');
//   const [isHighlighted, setIsHighlighted] = useState(false);

//   const handleInputFocus = () => {
//     setIsHighlighted(true);
//     setBorderHighlighted(false);
//   };

//   const handleInputBlur = () => {
//     setIsHighlighted(false);
//     setBorderHighlighted(false);
//   };

//   var filteredVoices = options.filter((voice: any) => {
//     const matchesDescription = voice.label
//       .toLowerCase()
//       .includes(searchText.toLowerCase());

//     const matchesGender =
//       selectedGender === '' || voice.gender === selectedGender;

//     // Filter based on accent
//     const matchesAccent =
//       selectedAccent === '' || voice.accent === selectedAccent;

//     const matchesSubcategories =
//       selectedFilters.length === 0 ||
//       voice.subcategories.some((subcategorySet: any) =>
//         selectedFilters.some((filter) => subcategorySet.includes(filter)),
//       );

//     // Filter based on age
//     const matchesAge = selectedAge === '' || voice.age === selectedAge;

//     return (
//       matchesDescription &&
//       matchesSubcategories &&
//       matchesGender &&
//       matchesAccent &&
//       matchesAge
//     );
//   });

//   const filterByVoiceId = (voiceIdToFilter: any) => {
//     const filteredVoices = options.filter(
//       (voice: any) => voice.value === voiceIdToFilter,
//     );
//     // Replace 'voice_2' with the desired voiceId
//     let lbl;
//     // Output the label(s) from the filtered result
//     filteredVoices.forEach((voice: any) => {
//       lbl = voice.label; // Prints the label(s) of the filtered voice(s)
//     });
//     return lbl;
//   };
//   const [bgColors, setBgColors] = useState<string[]>(
//     Array(filteredVoices.length).fill('transparent'),
//   );

//   const [borderColors, setBorderColors] = useState<string[]>(
//     Array(filteredVoices.length).fill('1px solid #cacfd8'),
//   );

//   const [isSecondGridVisible, setIsSecondGridVisible] = useState(false);
//   const [isBorderHighlighted, setBorderHighlighted] = useState(false);
//   const toggleSecondGrid = () => {
//     setIsSecondGridVisible(!isSecondGridVisible);
//     setBorderHighlighted(true);
//   };

//   const handleGenderChange = (selectedOption: any) => {
//     setSelectedGender(selectedOption ? selectedOption.value : '');
//   };

//   const handleAccentChange = (selectedOption: any) => {
//     setSelectedAccent(selectedOption ? selectedOption.value : '');
//   };

//   const handleAgeChange = (selectedOption: any) => {
//     setSelectedAge(selectedOption ? selectedOption.value : '');
//   };

//   // Event handler for search input change
//   const handleSearchInputChange = (e: any) => {
//     setSearchText(e.target.value);
//   };

//   const handleClearFilters = () => {
//     setSearchText('');
//     setSelectedGender('');
//     setSelectedAccent('');
//     setSelectedAge('');
//     setSelectedFilters([]);
//     filteredVoices = voices.map((it: any, ind: number) => {
//       const { age, accent, gender, ...remainingLabels } = it.labels;
//       const subcategories = Object.values(remainingLabels);
//       return {
//         label: it.name,
//         value: it.voice_id,
//         subcategories: subcategories,
//         audio: it.preview_url,
//         index: ind,
//         age: age,
//         accent: accent,
//         gender: gender,
//       };
//     });
//   };

//   const [showLeftButton, setShowLeftButton] = useState(false);

//   const [showcount, setShowcount] = useState<any>('');

//   const handleLeft = () => {
//     const container = document.getElementById('scroll');
//     if (container) {
//       container.scrollLeft -= 200;

//       if (container.scrollLeft <= 0) {
//         setShowLeftButton(false);
//       }
//     }
//   };

//   const handleRight = () => {
//     const container = document.getElementById('scroll');

//     if (container) {
//       container.scrollLeft += 200;
//       setShowcount(container.scrollLeft + 300);
//       if (container.scrollLeft > 0) {
//         setShowLeftButton(true);
//       }
//     }
//   };
//   const capitalizeFirstLetter = (e: any) => {
//     return e ? e.charAt(0).toUpperCase() + e.slice(1) : '';
//   };
//   return (
//     <>
//       <Modal isOpen={setPreview} onClose={setPreview} size="full">
//         <ModalOverlay />
//         <ModalContent
//           position="fixed"
//           overflowY="auto"
//           m={0}
//           className={'model_class'}
//           containerProps={{ zIndex: 999999 }}
//         >
//           <ModalBody p={'0 20px'}>
//             <Flex
//               flexDirection={{
//                 base: 'column',
//                 sm: 'column',
//                 md: 'column',
//                 lg: 'column',
//               }}
//               justifyContent={{
//                 base: 'start',
//                 sm: 'start',
//                 md: 'start',
//                 lg: 'start',
//               }}
//               alignItems={{
//                 base: 'center',
//                 sm: 'center',
//                 md: 'center',
//                 lg: 'start',
//               }}
//               height="80vh"
//               padding={'20px 0'}
//               background="#ffffff"
//             >
//               <Box width={'100%'} display={'flex'} justifyContent={'end'}>
//                 <ModalCloseButton position={'relative'} top={0} />
//               </Box>
//               <Box
//                 display={'flex'}
//                 w={'100%'}
//                 flexDir={{
//                   base: 'column',
//                   sm: 'column',
//                   md: 'column',
//                   lg: 'row',
//                 }}
//               >
//                 {formData.gameNonPlayingCharacterId !== previewId ? (
//                   <Card
//                     w={{ base: '100%', sm: '100%', md: '100%', lg: '70%' }}
//                     mb={{ base: '0px', sm: '0px', lg: '20px' }}
//                     h={{ base: '40vh', sm: '40vh', md: '40vh', lg: '90vh' }}
//                     backgroundImage={img}
//                     backgroundSize={'cover'}
//                     backgroundPosition={'center'}
//                     backgroundRepeat={'no-repeat'}
//                     alignItems={'end'}
//                     justifyContent={'flex-end'}
//                   >
//                     <Img
//                       src={find_Selected_fullimage?.src}
//                       width={'31%'}
//                       height={'78%'}
//                       marginRight={'11%'}
//                     />
//                   </Card>
//                 ) : prev ? (
//                   <Card
//                     w={{ base: '100%', sm: '100%', md: '100%', lg: '70%' }}
//                     mb={{ base: '0px', sm: '0px', lg: '20px' }}
//                     h={{ base: '40vh', sm: '40vh', md: '40vh', lg: '90vh' }}
//                     backgroundImage={img}
//                     backgroundSize={'cover'}
//                     backgroundPosition={'center'}
//                     backgroundRepeat={'no-repeat'}
//                     alignItems={'end'}
//                     justifyContent={'flex-end'}
//                   >
//                     <Img
//                       src={find_Selected_fullimage?.src}
//                       width={'31%'}
//                       height={
//                         [
//                           'Nova, the Customer',
//                           'Lena, the Team Leader',
//                           'Evelina, the Artisan',
//                           'Olivia, the Manager',
//                         ].includes(selectedPlayer?.gasAssetName)
//                           ? '78%'
//                           : '78%'
//                       }
//                       marginRight={'11%'}
//                     />
//                   </Card>
//                 ) : (
//                   <Box flex="1" p={4} w={'80%'}>
//                     <Image
//                       src={find_Selected_fullimage?.src}
//                       alt="Your Image"
//                       maxH="675px"
//                       mb="4"
//                     />
//                   </Box>
//                 )}
//                 {formData.gameNonPlayingCharacterId !== previewId ? (
//                   <Card
//                     flex="1"
//                     w={{ base: '100%', sm: '100%', md: '100%', lg: '30%' }}
//                     h={'max-content'}
//                     m={{
//                       base: '20px 0 20px 0',
//                       sm: '20px 0 20px 0',
//                       lg: '0 0 20px 20px',
//                     }}
//                     p={4}
//                     boxShadow={'5px 5px 20px #c5c5c5'}
//                   >
//                     <Flex direction="column" mb="20px" mt="0px">
//                       <Text
//                         fontSize={'1.25rem'}
//                         color={'#1B2559'}
//                         fontWeight={'700'}
//                       >
//                         Non Playing Character
//                       </Text>
//                       <Text
//                         fontSize={'1rem'}
//                         style={{ whiteSpace: 'pre-wrap' }}
//                       >
//                         {selectedPlayer?.gasAssetName
//                           ? capitalizeFirstLetter(selectedPlayer.gasAssetName)
//                           : ''}
//                       </Text>
//                     </Flex>{' '}
//                     <Button
//                       bg="#3311db"
//                       _hover={{ bg: '#3311db' }}
//                       color="#fff"
//                       w="100%"
//                       onClick={() =>
//                         makeInputFiled(previewId, selectedPlayer?.gasAssetName)
//                       }
//                     >
//                       Select
//                     </Button>
//                   </Card>
//                 ) : (
//                   <Card
//                     flex="1"
//                     w={{ base: '100%', sm: '100%', md: '100%', lg: '30%' }}
//                     h={'max-content'}
//                     m={{
//                       base: '20px 0 20px 0',
//                       sm: '20px 0 20px 0',
//                       lg: '0 0 20px 20px',
//                     }}
//                     p={4}
//                     boxShadow={'5px 5px 20px #c5c5c5'}
//                   >
//                     <Flex direction="column" mb="20px" mt="0px">
//                       <Text
//                         fontSize="xl"
//                         ml="1px"
//                         color={textColorPrimary}
//                         fontWeight="bold"
//                       >
//                         Edit Name
//                       </Text>
//                     </Flex>
//                     <FormControl mb="5px">
//                       <InputField
//                         id="title"
//                         placeholder="eg. Oliver"
//                         isRequired={true}
//                         label="Non-Player Name"
//                         name="gameTitle"
//                         value={formData?.gameNonPlayerName}
//                         onChange={(
//                           e: React.ChangeEvent<
//                             HTMLSelectElement | HTMLInputElement
//                           >,
//                         ) => {
//                           handleChange(
//                             e as React.ChangeEvent<HTMLSelectElement>,
//                           );
//                         }}
//                         w="100%"
//                         mb="0px"
//                       />
//                     </FormControl>
//                     <Flex direction="column" mb="20px" mt="10px">
//                       <Text
//                         fontSize="xl"
//                         color={textColorPrimary}
//                         fontWeight="bold"
//                       >
//                         Select Voices
//                       </Text>
//                       <Text ml="1px" fontSize="md" color={textColorSecondary}>
//                         The voices selected for the characters will play only
//                         after the game has been created entirely.
//                       </Text>
//                     </Flex>

//                     <FormControl mb="5px">
//                       <>
//                         <SimpleGrid
//                           columns={{ sm: 8, md: 8, xl: 8 }}
//                           w="100%"
//                           mb="0px"
//                           mt="0px"
//                         >
//                           <Box
//                             gridColumn={{
//                               sm: 'span 7',
//                               md: 'span 7',
//                               xl: 'span 7',
//                             }}
//                             mb="-10px"
//                             alignItems="center"
//                             mr="0px"
//                           >
//                             <InputField
//                               id="title"
//                               isRequired={true}
//                               name="Non-PlayerVoice"
//                               readOnly="readOnly"
//                               w="100%"
//                               label="Non-Player Voice"
//                               value={
//                                 formData.gameNonPlayerVoice !== ''
//                                   ? filterByVoiceId(formData.gameNonPlayerVoice)
//                                   : chosenVoiceNPC
//                               }
//                               borderColor={
//                                 formData.gameNonPlayerVoice === '' ||
//                                 formData.gameNonPlayerVoice === null
//                                   ? 'red'
//                                   : null
//                               }
//                               // m="0px"
//                             />
//                           </Box>
//                           <Box
//                             gridColumn={{
//                               sm: 'span 1',
//                               xl: 'span 1',
//                               md: 'span 1',
//                             }}
//                             pt="29px"
//                             ml="0px"
//                             mb="5px"
//                             justifyContent="center"
//                             alignItems="center"
//                           >
//                             <div
//                               style={customStylesBtn}
//                               onClick={() => handleAddVoice('NPC')}
//                             >
//                               <MdOutlineAdd
//                                 size={20}
//                                 color={iconColor}
//                                 onMouseEnter={handleMouseEnter}
//                                 onMouseLeave={handleMouseLeave}
//                               />
//                             </div>
//                           </Box>
//                         </SimpleGrid>

//                         <Modal
//                           isOpen={showModal}
//                           onClose={closeModal}
//                           size="full"
//                         >
//                           <ModalOverlay />
//                           <ModalContent containerProps={{ zIndex: 999999 }}>
//                             <ModalBody>
//                               <>
//                                 <Box
//                                   style={{
//                                     position: 'sticky',
//                                     top: '0',
//                                     background: 'white',
//                                     zIndex: 1000,
//                                   }}
//                                 >
//                                   <ModalHeader></ModalHeader>
//                                   <ModalCloseButton />
//                                   <SimpleGrid
//                                     columns={{ sm: 1, md: 1, xl: 16 }}
//                                     w="100%"
//                                     border={'1px solid grey'}
//                                     alignItems="center"
//                                     style={{
//                                       position: 'sticky',
//                                       top: '0',
//                                       background: 'white',
//                                       zIndex: 1000,
//                                     }}
//                                   >
//                                     <Box
//                                       gridColumn={{
//                                         sm: 'span 16',
//                                         md: 'span 4',
//                                         xl: 'span 4',
//                                       }}
//                                       mr="0px"
//                                       border={`2px solid ${
//                                         isHighlighted ? 'grey' : 'lightgrey'
//                                       }`}
//                                       borderRadius="4px"
//                                       bg={
//                                         isHighlighted
//                                           ? 'transparent'
//                                           : 'transparent'
//                                       }
//                                       display={'flex'}
//                                       alignItems={'center'}
//                                     >
//                                       <InputField
//                                         mt={'17px'}
//                                         mb={{
//                                           base: '10px',
//                                           sm: '10px',
//                                           md: '30px',
//                                         }}
//                                         bg="transparent"
//                                         placeholder="Search Voices..."
//                                         margin="0px"
//                                         border="none"
//                                         p="20px"
//                                         fontSize="0.875rem"
//                                         onFocus={handleInputFocus}
//                                         onBlur={handleInputBlur}
//                                         onChange={(e: any) =>
//                                           handleSearchInputChange(e)
//                                         }
//                                       />
//                                     </Box>

//                                     <Box
//                                       p="10px"
//                                       gridColumn={{
//                                         sm: 'span 15',
//                                         md: 'span 11',
//                                         xl: 'span 11',
//                                       }}
//                                       display="flex"
//                                       flexDirection="column"
//                                     >
//                                       <Box
//                                         display="flex"
//                                         alignItems="center"
//                                         flexWrap="nowrap"
//                                         overflowX="hidden"
//                                         mr="0px"
//                                         id={'scroll'}
//                                       >
//                                         {filteredSubcategories.map(
//                                           (subcategory: any, index: any) => (
//                                             <Text
//                                               key={index}
//                                               fontSize="sm"
//                                               display="flex"
//                                               flexWrap="nowrap"
//                                               fontWeight="700"
//                                               float={'left'}
//                                               whiteSpace="pre"
//                                               border={'1px solid #11047a'}
//                                               borderRadius={'10px'}
//                                               color={
//                                                 selectedFilters.includes(
//                                                   subcategory,
//                                                 )
//                                                   ? 'white'
//                                                   : 'black'
//                                               }
//                                               bg={
//                                                 selectedFilters.includes(
//                                                   subcategory,
//                                                 )
//                                                   ? '#11047a'
//                                                   : 'transparent'
//                                               }
//                                               onClick={() =>
//                                                 handleFilterClick(subcategory)
//                                               }
//                                               style={{
//                                                 cursor: 'pointer',
//                                                 marginRight: '10px',
//                                                 marginBottom: '5px',
//                                                 padding: '8px',
//                                               }}
//                                             >
//                                               {subcategory}
//                                             </Text>
//                                           ),
//                                         )}
//                                       </Box>
//                                       <Box
//                                         display={'flex'}
//                                         justifyContent={'space-between'}
//                                         alignItems="flex-end"
//                                       >
//                                         <Icon
//                                           as={FaChevronLeft}
//                                           style={{
//                                             fontSize: '10px',
//                                             cursor: 'pointer',
//                                             marginBottom: '5px',
//                                             display: 'block',
//                                           }}
//                                           onClick={handleLeft}
//                                         />
//                                         <Icon
//                                           as={FaChevronRight}
//                                           style={{
//                                             fontSize: '10px',
//                                             cursor: 'pointer',
//                                             marginTop: '5px',
//                                             display: 'block',
//                                           }}
//                                           onClick={handleRight}
//                                         />
//                                       </Box>
//                                     </Box>
//                                     <Box
//                                       p="30px"
//                                       gridColumn={{
//                                         sm: 'span 1',
//                                         md: 'span 1',
//                                         xl: 'span 1',
//                                       }}
//                                       onClick={toggleSecondGrid}
//                                       display="flex"
//                                       alignItems="center"
//                                       border={`2px solid ${
//                                         isBorderHighlighted
//                                           ? 'grey'
//                                           : 'lightgrey'
//                                       }`}
//                                       flexWrap="nowrap"
//                                       overflowX="scroll"
//                                       mr="0px"
//                                     >
//                                       {isSecondGridVisible ? (
//                                         <Icon
//                                           as={FaWindowClose}
//                                           style={customStylesicon}
//                                         />
//                                       ) : (
//                                         <Icon
//                                           as={FaSlidersH}
//                                           style={customStylesicon}
//                                         />
//                                       )}
//                                     </Box>
//                                   </SimpleGrid>

//                                   {isSecondGridVisible && (
//                                     <motion.div
//                                       initial={{
//                                         opacity: 0,
//                                         height: 0,
//                                         transform: 'translateY(-50px)',
//                                       }}
//                                       animate={{
//                                         opacity: isSecondGridVisible ? 1 : 0.5,
//                                         height: isSecondGridVisible
//                                           ? '100%'
//                                           : 0,
//                                         transform: isSecondGridVisible
//                                           ? 'translateY(0px)'
//                                           : 'translateY(-50px)',
//                                       }}
//                                       transition={{
//                                         duration: 0.3,
//                                         ease: 'easeInOut',
//                                       }}
//                                       className="voice-library-filters"
//                                       style={{
//                                         // overflow: "hidden",
//                                         border: '1px solid grey',
//                                         background: '#ececec',
//                                         gridColumn: 'span 16', // Adjust this to your grid layout
//                                         width: '100%',
//                                         alignItems: 'center',
//                                         display: 'flex', // Add this line

//                                         position: 'sticky',
//                                         top: '11%',
//                                         zIndex: 999,
//                                         borderTop: 'none',
//                                       }}
//                                     >
//                                       <Box
//                                         pl={{ base: '0', sm: '0', lg: '20px' }}
//                                         pr={{ base: '0', sm: '0', lg: '150px' }}
//                                         gridColumn={{
//                                           sm: 'span 16',
//                                           md: 'span 4',
//                                           xl: 'span 4',
//                                         }}
//                                         alignItems="center"
//                                       >
//                                         <Box
//                                           style={{
//                                             margin: '0',
//                                             paddingTop: '20px',
//                                             paddingBottom: '20px',
//                                           }}
//                                         >
//                                           <Text
//                                             fontSize="13px"
//                                             color={textColorPrimary}
//                                           >
//                                             ADVANCED FILTERS
//                                           </Text>
//                                         </Box>
//                                       </Box>

//                                       <Box
//                                         p="10px"
//                                         gridColumn={{
//                                           sm: 'span 14',
//                                           md: 'span 10',
//                                           xl: 'span 10',
//                                         }}
//                                         display="flex"
//                                         flexDir={{
//                                           base: 'column',
//                                           sm: 'column',
//                                           lg: 'row',
//                                         }}
//                                         alignItems="center"
//                                         mr="0px"
//                                         position="relative"
//                                       >
//                                         <Box
//                                           position={{
//                                             base: 'unset',
//                                             sm: 'unset',
//                                             lg: 'absolute',
//                                           }}
//                                           mr={{ base: '0', sm: 0, lg: '20px' }}
//                                           style={{
//                                             left: '-130px',
//                                             width: '150px',
//                                             zIndex: '500',
//                                           }}
//                                         >
//                                           <Select
//                                             placeholder="Gender"
//                                             options={genderOptions}
//                                             // styles={customStyles}
//                                             menuPortalTarget={document.body}
//                                             styles={{
//                                               menuPortal: (base) => ({
//                                                 ...base,
//                                                 zIndex: 999999,
//                                               }),
//                                               option: (
//                                                 provided: any,
//                                                 state: any,
//                                               ) => ({
//                                                 ...provided,
//                                                 backgroundColor: state.isFocused
//                                                   ? '#e0e0e0'
//                                                   : 'transparent',
//                                                 cursor: 'pointer',
//                                                 color: 'black',
//                                                 zIndex: '101',
//                                                 '&:hover': {
//                                                   backgroundColor: '#e0e0e0', // Change background color on hover
//                                                 },
//                                               }),
//                                             }}
//                                             value={
//                                               // Conditionally set the value based on some condition
//                                               selectedGender !== ''
//                                                 ? genderOptions.find(
//                                                     (option) =>
//                                                       option.value ===
//                                                       selectedGender,
//                                                   )
//                                                 : ''
//                                             }
//                                             onChange={handleGenderChange}
//                                           />
//                                         </Box>
//                                         <Box
//                                           position={{
//                                             base: 'unset',
//                                             sm: 'unset',
//                                             lg: 'absolute',
//                                           }}
//                                           mr={{ base: '0', sm: 0, lg: '20px' }}
//                                           style={{
//                                             left: '50px',
//                                             width: '150px',
//                                             zIndex: '500',
//                                           }}
//                                         >
//                                           {/* Render other dropdowns similarly */}
//                                           <Select
//                                             placeholder="Accent"
//                                             options={accentOptions}
//                                             // styles={customStyles}
//                                             menuPortalTarget={document.body}
//                                             styles={{
//                                               menuPortal: (base) => ({
//                                                 ...base,
//                                                 zIndex: 999999,
//                                               }),
//                                               option: (
//                                                 provided: any,
//                                                 state: any,
//                                               ) => ({
//                                                 ...provided,
//                                                 backgroundColor: state.isFocused
//                                                   ? '#e0e0e0'
//                                                   : 'transparent',
//                                                 cursor: 'pointer',
//                                                 color: 'black',
//                                                 zIndex: '101',
//                                                 '&:hover': {
//                                                   backgroundColor: '#e0e0e0', // Change background color on hover
//                                                 },
//                                               }),
//                                             }}
//                                             value={
//                                               selectedAccent !== ''
//                                                 ? accentOptions.find(
//                                                     (option) =>
//                                                       option.value ===
//                                                       selectedAccent,
//                                                   )
//                                                 : ''
//                                             }
//                                             onChange={handleAccentChange}
//                                           />
//                                         </Box>{' '}
//                                         <Box
//                                           position={{
//                                             base: 'unset',
//                                             sm: 'unset',
//                                             lg: 'absolute',
//                                           }}
//                                           mr={{ base: '0', sm: 0, lg: '20px' }}
//                                           style={{
//                                             left: '230px',
//                                             width: '150px',
//                                             zIndex: '500',
//                                           }}
//                                         >
//                                           <Select
//                                             placeholder="Age"
//                                             options={ageOptions}
//                                             menuPortalTarget={document.body}
//                                             styles={{
//                                               menuPortal: (base) => ({
//                                                 ...base,
//                                                 zIndex: 999999,
//                                               }),
//                                               option: (
//                                                 provided: any,
//                                                 state: any,
//                                               ) => ({
//                                                 ...provided,
//                                                 backgroundColor: state.isFocused
//                                                   ? '#e0e0e0'
//                                                   : 'transparent',
//                                                 cursor: 'pointer',
//                                                 color: 'black',
//                                                 zIndex: '101',
//                                                 '&:hover': {
//                                                   backgroundColor: '#e0e0e0',
//                                                 },
//                                               }),
//                                             }}
//                                             value={
//                                               selectedAge !== ''
//                                                 ? ageOptions.find(
//                                                     (option) =>
//                                                       option.value ===
//                                                       selectedAge,
//                                                   )
//                                                 : ''
//                                             }
//                                             onChange={handleAgeChange}
//                                           />{' '}
//                                         </Box>
//                                       </Box>
//                                       <Box
//                                         p="5px"
//                                         gridColumn={{
//                                           sm: 'span 2',
//                                           md: 'span 2',
//                                           xl: 'span 2',
//                                         }}
//                                         display="flex"
//                                         alignItems="center"
//                                         mr="0px"
//                                       >
//                                         <Button
//                                           variant="light"
//                                           fontSize="sm"
//                                           borderRadius="16px"
//                                           position={{
//                                             base: 'unset',
//                                             sm: 'unset',
//                                             lg: 'absolute',
//                                           }}
//                                           zIndex="500"
//                                           right="-60px"
//                                           h="46px"
//                                           m={{ base: '0', sm: '0', lg: '80px' }}
//                                           onClick={handleClearFilters}
//                                         >
//                                           Clear All
//                                         </Button>
//                                       </Box>
//                                     </motion.div>
//                                   )}
//                                 </Box>
//                               </>

//                               <Box w={'100%'} mt="20px" p="20px">
//                                 <>
//                                   <Flex direction="column" mb="20px" mt="0px">
//                                     <Text
//                                       fontSize="34px"
//                                       color={textColorPrimary}
//                                       fontWeight="700"
//                                     >
//                                       Voice Library
//                                     </Text>
//                                     <Text
//                                       fontSize="md"
//                                       color={textColorSecondary}
//                                     >
//                                       Here you can discover voices
//                                     </Text>
//                                   </Flex>
//                                   <SimpleGrid
//                                     columns={{ sm: 1, md: 2, xl: 4 }}
//                                     spacing={{ base: '20px', xl: '20px' }}
//                                   >
//                                     {filteredVoices.map(
//                                       (voice: any, index: number) => {
//                                         let bg = 'transparent';
//                                         let bg2 = 'transparent';
//                                         let border = '1px solid #cacfd8';

//                                         if (chosenModal === 'NPC') {
//                                           bg =
//                                             formData.gameNonPlayerVoice ===
//                                             voice.value
//                                               ? boxBg
//                                               : bgColors[index];
//                                           bg2 =
//                                             formData.gameNonPlayerVoice ===
//                                             voice.value
//                                               ? '#11047a'
//                                               : 'transparent';
//                                           border =
//                                             formData.gameNonPlayerVoice ===
//                                             voice.value
//                                               ? '2px solid #11047a'
//                                               : borderColors[index];
//                                         } else if (chosenModal === 'MALE') {
//                                           bg =
//                                             formData.gamePlayerMaleVoice ===
//                                             voice.value
//                                               ? boxBg
//                                               : bgColors[index];
//                                           bg2 =
//                                             formData.gamePlayerMaleVoice ===
//                                             voice.value
//                                               ? '#11047a'
//                                               : 'transparent';
//                                           border =
//                                             formData.gamePlayerMaleVoice ===
//                                             voice.value
//                                               ? '2px solid #11047a'
//                                               : borderColors[index];
//                                         } else if (chosenModal === 'FEMALE') {
//                                           bg =
//                                             formData.gamePlayerFemaleVoice ===
//                                             voice.value
//                                               ? boxBg
//                                               : bgColors[index];
//                                           bg2 =
//                                             formData.gamePlayerFemaleVoice ===
//                                             voice.value
//                                               ? '#11047a'
//                                               : 'transparent';
//                                           border =
//                                             formData.gamePlayerFemaleVoice ===
//                                             voice.value
//                                               ? '2px solid #11047a'
//                                               : borderColors[index];
//                                         } else if (chosenModal === 'NARRATOR') {
//                                           bg =
//                                             formData.gameNarratorVoice ===
//                                             voice.value
//                                               ? boxBg
//                                               : bgColors[index];
//                                           bg2 =
//                                             formData.gameNarratorVoice ===
//                                             voice.value
//                                               ? '#11047a'
//                                               : 'transparent';
//                                           border =
//                                             formData.gameNarratorVoice ===
//                                             voice.value
//                                               ? '2px solid #11047a'
//                                               : borderColors[index];
//                                         }
//                                         const isVoiceSelected =
//                                           (chosenModal === 'NPC' &&
//                                             formData.gameNonPlayerVoice ===
//                                               voice.value) ||
//                                           (chosenModal === 'MALE' &&
//                                             formData.gamePlayerMaleVoice ===
//                                               voice.value) ||
//                                           (chosenModal === 'FEMALE' &&
//                                             formData.gamePlayerFemaleVoice ===
//                                               voice.value) ||
//                                           (chosenModal === 'NARRATOR' &&
//                                             formData.gameNarratorVoice ===
//                                               voice.value);

//                                         return (
//                                           <Flex
//                                             key={voice.value}
//                                             direction="column"
//                                             bg={bg}
//                                             mb="38px"
//                                             className="flex-item"
//                                             borderRadius={'10px'}
//                                             border={border}
//                                             position="relative"
//                                             boxShadow="0px 4px 12px rgba(0, 0, 0, 0.1)"
//                                           >
//                                             <Box
//                                               p="16px 20px"
//                                               lineHeight={'1.25rem'}
//                                             >
//                                               {isVoiceSelected && (
//                                                 <Flex
//                                                   position="absolute"
//                                                   top="-10px"
//                                                   right="-10px"
//                                                   width="20px"
//                                                   height="20px"
//                                                   borderRadius="50%"
//                                                   bg={bg2}
//                                                   alignItems="center"
//                                                   justifyContent="center"
//                                                   zIndex="1"
//                                                   overflow="hidden"
//                                                 >
//                                                   <Icon
//                                                     as={MdOutlineCheck}
//                                                     w="15px"
//                                                     h="15px"
//                                                     color="white"
//                                                   />
//                                                 </Flex>
//                                               )}
//                                               <Text
//                                                 fontSize="sm"
//                                                 fontWeight="700"
//                                                 color={'black'}
//                                               >
//                                                 {voice.label}
//                                               </Text>
//                                               <Text
//                                                 fontSize="sm"
//                                                 fontWeight="500"
//                                                 color={'black'}
//                                                 textTransform={'capitalize'}
//                                               >
//                                                 {voice.age} {voice.accent}{' '}
//                                                 {voice.gender}
//                                               </Text>
//                                               <Box
//                                                 style={{
//                                                   display: 'flex',
//                                                   alignItems: 'center',
//                                                 }}
//                                               >
//                                                 <Box
//                                                   style={{ display: 'flex' }}
//                                                   fontSize={'14px'}
//                                                 >
//                                                   {voice.subcategories &&
//                                                     voice.subcategories.length >
//                                                       0 && (
//                                                       <Box
//                                                         style={{
//                                                           display: 'flex',
//                                                           marginRight: '12px',
//                                                           gap: '.25rem',
//                                                         }}
//                                                       >
//                                                         {voice.subcategories.map(
//                                                           (
//                                                             subcategory: any,
//                                                             index: number,
//                                                           ) => (
//                                                             <Box
//                                                               key={index}
//                                                               style={{
//                                                                 borderRadius:
//                                                                   '20px',
//                                                                 whiteSpace:
//                                                                   'nowrap',
//                                                                 fontSize:
//                                                                   '0.775rem',
//                                                                 fontWeight:
//                                                                   '400',
//                                                                 paddingRight:
//                                                                   '6px',
//                                                                 paddingLeft:
//                                                                   '6px',
//                                                                 backgroundColor:
//                                                                   colors[index],
//                                                                 marginRight:
//                                                                   '4px',
//                                                               }}
//                                                             >
//                                                               {subcategory}
//                                                             </Box>
//                                                           ),
//                                                         )}
//                                                       </Box>
//                                                     )}
//                                                 </Box>
//                                               </Box>
//                                             </Box>

//                                             <div
//                                               style={{
//                                                 borderTop: '1px solid #cacfd8',
//                                                 marginTop: '10px',
//                                                 width: '100%',
//                                                 float: 'left', // Pushes buttons to the bottom
//                                               }}
//                                             >
//                                               <Button
//                                                 bg={'transparent'}
//                                                 w={'50%'}
//                                                 borderRadius={'0px'}
//                                                 p={'0px'}
//                                                 fontSize={'0.875rem'}
//                                                 fontWeight={'600'}
//                                                 borderRight={
//                                                   '1px solid #cacfd8'
//                                                 }
//                                                 onClick={(e) =>
//                                                   handleClick(e, voice)
//                                                 }
//                                                 disabled={
//                                                   isPlaying ? true : false
//                                                 }
//                                               >
//                                                 <Box
//                                                   style={{
//                                                     marginLeft: '4px',
//                                                     marginRight: '12px',
//                                                   }}
//                                                   h={'100%'}
//                                                   display={'flex'}
//                                                   alignItems={'center'}
//                                                 >
//                                                   {isPlaying &&
//                                                   selectedVoice.value ==
//                                                     voice.value ? (
//                                                     <Spinner />
//                                                   ) : (
//                                                     <>
//                                                       {' '}
//                                                       <Icon
//                                                         as={FaVolumeUp}
//                                                         style={customStylesicon}
//                                                       />{' '}
//                                                       <span
//                                                         style={customStylesicon}
//                                                       >
//                                                         Sample
//                                                       </span>
//                                                     </>
//                                                   )}
//                                                 </Box>
//                                               </Button>

//                                               <Button
//                                                 w={'50%'}
//                                                 p={'0px'}
//                                                 bg={'transparent'}
//                                                 fontSize={'0.875rem'}
//                                                 fontWeight={'600'}
//                                                 borderRadius={'0px'}
//                                                 onClick={() =>
//                                                   handleSelectChange(
//                                                     voice,
//                                                     chosenModal,
//                                                   )
//                                                 }
//                                               >
//                                                 <>
//                                                   {' '}
//                                                   <Icon
//                                                     as={FaPlusCircle}
//                                                     style={customStylesicon}
//                                                   />{' '}
//                                                   <span
//                                                     style={customStylesicon}
//                                                   >
//                                                     Add to Character
//                                                   </span>
//                                                 </>
//                                               </Button>
//                                             </div>
//                                           </Flex>
//                                         );
//                                       },
//                                     )}
//                                   </SimpleGrid>
//                                   {filteredVoices.length === 0 && (
//                                     <Box p="20px" textAlign="center">
//                                       <Text fontSize="7vw" color="#858c9757">
//                                         No Voice Found
//                                       </Text>
//                                     </Box>
//                                   )}

//                                   {filteredVoices.map(
//                                     (voice: any, index: number) => (
//                                       <div key={index}></div>
//                                     ),
//                                   )}
//                                 </>
//                               </Box>
//                             </ModalBody>
//                           </ModalContent>
//                         </Modal>
//                       </>
//                     </FormControl>

//                     <FormControl mb="-5px">
//                       <SimpleGrid columns={{ sm: 8, md: 8, xl: 8 }} w="100%">
//                         <Box
//                           gridColumn={{
//                             sm: 'span 7',
//                             md: 'span 7',
//                             xl: 'span 7',
//                           }}
//                           alignItems="center"
//                           mr="0px"
//                         >
//                           <InputField
//                             id="male"
//                             isRequired={true}
//                             name="PlayerMaleVoice"
//                             readOnly="readOnly"
//                             w="100%"
//                             label="Player Male Voice"
//                             borderColor={
//                               formData.gamePlayerMaleVoice === '' ||
//                               formData.gamePlayerMaleVoice === null
//                                 ? 'red'
//                                 : null
//                             }
//                             value={
//                               formData.gamePlayerMaleVoice !== ''
//                                 ? filterByVoiceId(formData.gamePlayerMaleVoice)
//                                 : chosenVoiceMALE
//                             }
//                             m="0px"
//                           />
//                         </Box>
//                         <Box
//                           gridColumn={{
//                             sm: 'span 1',
//                             xl: 'span 1',
//                             md: 'span 1',
//                           }}
//                           pt="29px"
//                           ml="0px"
//                           justifyContent="center"
//                           alignItems="center"
//                         >
//                           <div
//                             style={customStylesBtn}
//                             onClick={() => handleAddVoice('MALE')}
//                           >
//                             <MdOutlineAdd
//                               size={20}
//                               color={iconColor}
//                               onMouseEnter={handleMouseEnter}
//                               onMouseLeave={handleMouseLeave}
//                             />
//                           </div>
//                         </Box>
//                       </SimpleGrid>
//                     </FormControl>
//                     <FormControl mb="-5px">
//                       <SimpleGrid
//                         columns={{ sm: 8, md: 8, xl: 8 }}
//                         w="100%"
//                         mt="0px"
//                       >
//                         <Box
//                           gridColumn={{
//                             sm: 'span 7',
//                             md: 'span 7',
//                             xl: 'span 7',
//                           }}
//                           alignItems="center"
//                           mr="0px"
//                         >
//                           <InputField
//                             id="female"
//                             isRequired={true}
//                             name="PlayerFemaleVoice"
//                             readOnly="readOnly"
//                             w="100%"
//                             label="Player Female Voice"
//                             borderColor={
//                               formData.gamePlayerFemaleVoice === '' ||
//                               formData.gamePlayerFemaleVoice === null
//                                 ? 'red'
//                                 : null
//                             }
//                             value={
//                               formData.gamePlayerFemaleVoice !== ''
//                                 ? filterByVoiceId(
//                                     formData.gamePlayerFemaleVoice,
//                                   )
//                                 : chosenVoiceFEMALE
//                             }
//                             m="0px"
//                           />
//                         </Box>
//                         <Box
//                           gridColumn={{
//                             sm: 'span 1',
//                             xl: 'span 1',
//                             md: 'span 1',
//                           }}
//                           pt="29px"
//                           ml="0px"
//                           justifyContent="center"
//                           alignItems="center"
//                         >
//                           <div
//                             style={customStylesBtn}
//                             onClick={() => handleAddVoice('FEMALE')}
//                           >
//                             <MdOutlineAdd
//                               size={20}
//                               color={iconColor}
//                               onMouseEnter={handleMouseEnter}
//                               onMouseLeave={handleMouseLeave}
//                             />
//                           </div>
//                         </Box>
//                       </SimpleGrid>
//                     </FormControl>

//                     <FormControl mb="-5px">
//                       <SimpleGrid columns={{ sm: 8, md: 8, xl: 8 }} w="100%">
//                         <Box
//                           gridColumn={{
//                             sm: 'span 7',
//                             md: 'span 7',
//                             xl: 'span 7',
//                           }}
//                           alignItems="center"
//                           mr="0px"
//                         >
//                           <InputField
//                             id="narrator"
//                             isRequired={true}
//                             name="NarratorVoice"
//                             readOnly="readOnly"
//                             w="100%"
//                             label="Narrator Voice"
//                             borderColor={
//                               formData.gameNarratorVoice === '' ||
//                               formData.gameNarratorVoice === null
//                                 ? 'red'
//                                 : null
//                             }
//                             value={
//                               formData.gameNarratorVoice !== ''
//                                 ? filterByVoiceId(formData.gameNarratorVoice)
//                                 : chosenVoiceNAR
//                             }
//                             m="0px"
//                           />
//                         </Box>
//                         <Box
//                           gridColumn={{
//                             sm: 'span 1',
//                             xl: 'span 1',
//                             md: 'span 1',
//                           }}
//                           pt="29px"
//                           ml="0px"
//                           mb="5px"
//                           justifyContent="center"
//                           alignItems="center"
//                         >
//                           <div
//                             style={customStylesBtn}
//                             onClick={() => handleAddVoice('NARRATOR')}
//                           >
//                             <MdOutlineAdd
//                               size={20}
//                               color={iconColor}
//                               onMouseEnter={handleMouseEnter}
//                               onMouseLeave={handleMouseLeave}
//                             />
//                           </div>
//                         </Box>
//                       </SimpleGrid>
//                     </FormControl>
//                     <Button
//                       bg="#3311db"
//                       _hover={{ bg: '#3311db' }}
//                       color="#fff"
//                       w="100%"
//                       onClick={commonNextFunction}
//                     >
//                       Submit
//                     </Button>
//                   </Card>
//                 )}
//               </Box>
//             </Flex>
//           </ModalBody>
//           <ModalFooter></ModalFooter>
//         </ModalContent>
//       </Modal>
//     </>
//   );
// };

// export default CharacterPreview;


// ****************************************************new CODE **************************************

import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Box,
  Flex,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  Text,
  SimpleGrid,
  useColorModeValue,
  Img,
  Icon,
  Spinner,
} from '@chakra-ui/react';
import InputField from 'components/fields/InputField';
import Card from 'components/card/Card';

import { MdOutlineAdd, MdOutlineCheck } from 'react-icons/md';
import Select from 'react-select';
import {
  FaVolumeUp,
  FaPlusCircle,
  FaSlidersH,
  FaWindowClose,
  FaChevronLeft,
  FaChevronRight,
} from 'react-icons/fa';
import { motion } from 'framer-motion';

const customStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#e0e0e0' : 'transparent',
    cursor: 'pointer',
    color: 'black',
    zIndex: '101',
    '&:hover': {
      backgroundColor: '#e0e0e0', // Change background color on hover
    },
  }),
};

const customStylesselect = {
  marginRight: '20px',
  position: 'absolute',
  zIndex: 101,
};
const customStylesicon = {
  cursor: 'pointer',
  color: 'grey',
  marginRight: '4px',
};
const customStylesBtn = {
  padding: '0px',
  marginBottom: '0px',
  marginTop: '0px',
  height: '44px',
  borderRadius: '5px',
  border: 'none',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  alignItems: 'center',
  alignContent: 'center',
  display: 'flex',
  justifyContent: 'center',
};

const CharacterPreview: React.FC<{
  id?: any;
  languages?: any;
  players?: any;
  setPreview?: any;
  makeInputFiled?: any;
  onClose?: any;
  values?: any;
  setValues?: any;
  previewId?: any;
  setFormData?: any;
  formData?: any;
  commonNextFunction?: any;
  voices: any;
  show: any;
  prev: any;
  staticAssetImageUrls: any;
}> = ({
  id,
  languages,
  prev,
  players,
  setPreview,
  makeInputFiled,
  onClose,
  values,
  setValues,
  previewId,
  setFormData,
  formData,
  voices,
  commonNextFunction,
  show,
  staticAssetImageUrls,
}) => {

  const textContent =
    'Game Content means any templates, modules, functions, features, images, audio data, video data, or other content that may be used by a Game Creator when creating a Game.';
  const truncatedText = textContent.slice(0, 80) + '...';
 
  const selectedPlayer = players.find(
    (player: any) => player.gasId === previewId,
  );
  const [selectedCharacter, setSelectedCharacter] = useState<any[]>([]);
  const gameNonPlayerOption = Array.isArray(formData?.gameNonPlayerOption)
  ? formData.gameNonPlayerOption
  : [];
    const handlePlayerChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = Number(e.target.value);
    if (!selectedId) return;

    const player = players.find((p: any) => p.gasId === selectedId);
    if (!player) return;

    // setSelectedCharacter((prev) => {
    //   if (prev.some((char) => char.gasId === player.gasId)) {
    //     return prev; // prevent duplicates
    //   }
    //   return [...prev, player];
    // });
    setSelectedCharacter((prev) => {
      // Prevent duplicates
      if (prev.some((char) => char.gasId === player.gasId)) {
        return prev;
      }
      const updatedCharacters = [...prev, player];
      // Update formData based on updated characters
      setFormData((prevForm: any) => ({
        ...prevForm,
        gameNonPlayerOption: updatedCharacters.map((char: any) => {
          const existing = prevForm.gameNonPlayerOption?.find(
            (npc: any) => Number(npc.gasId) === Number(char.gasId)
          );

          return (
            existing ?? {
              gasId: char.gasId,
              name: char.name ?? char.gasAssetName,
              voices: {
                npc: '',
                male: '',
                female: '',
                narrator: '',
              },
            }
          );
        }),
      }));

      return updatedCharacters;
      });

    e.target.value = '';
  };

  /* ----------------------------------------------------
     REMOVE NPC
  ---------------------------------------------------- */
  const handleRemovePlayer = (gasId: number) => {
    setSelectedCharacter((prev) =>
      prev.filter((char) => char.gasId !== gasId),
    );
    // Update formData.gameNonPlayerOption
    setFormData((prev: any) => ({
      ...prev,
      gameNonPlayerOption: prev.gameNonPlayerOption?.filter(
        (npc: any) => Number(npc.gasId) !== Number(gasId)
      ) || [],
    }));
  };


// useEffect(() => {
//   setFormData((prev: any) => ({
//     ...prev,
//     gameNonPlayerOption: selectedCharacter?.map((char: any) => {
//       const existing = prev.gameNonPlayerOption?.find(
//         (npc: any) => npc.gasId === char.gasId,
//       );

//       return (
//         existing || {
//           gasId: char.gasId,
//           name: char.gasAssetName,
//           voices: {
//             npc: '',
//             male: '',
//             female: '',
//             narrator: '',
//           },
//         }
//       );
//     }),
//   }));
// }, [selectedCharacter]);
useEffect(() => {
  if (
    formData?.gameNonPlayerName &&
    Array.isArray(formData?.gameNonPlayerOption)
  ) {
    const matched = formData.gameNonPlayerOption.filter(
      (item: any) => item.name === formData.gameNonPlayerName
    );

    const remaining = formData.gameNonPlayerOption.filter(
      (item: any) => item.name !== formData.gameNonPlayerName
    );

    setSelectedCharacter([...matched, ...remaining]);
    console.log("players",players)
  }
}, []);
const getCharacterDisplayName = (
  char: any,
  players: any[]
) => {
  // 1. If name exists, use it
  if (char?.name?.trim()) {
    return char.name;
  }

  // 2. Fallback: find from players using gasId
  const matchedPlayer = players.find(
    (p) => p.gasId === char?.gasId
  );

  return matchedPlayer?.gasAssetName || "";
};

  const handleNonPlayerVoice: React.ChangeEventHandler<HTMLSelectElement> = (
    e,
  ) => {
    setFormData((prev: any) => ({
      ...prev,
      gameNonPlayerVoice: e.target.value || '',
    }));
  };
  const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const textColorSecondary = 'secondaryGray.600';
  const [iconColor, setIconColor] = useState('grey');
  const handleMouseEnter = () => {
    setIconColor('black');
  };

  const handleMouseLeave = () => {
    setIconColor('grey');
  };
  const handlePlayerMale: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    setFormData((prev: any) => ({
      ...prev,
      gamePlayerMaleVoice: e.target.value || '',
    }));
  };

  const handlePlayerFemale: React.ChangeEventHandler<HTMLSelectElement> = (
    e,
  ) => {
    setFormData((prev: any) => ({
      ...prev,
      gamePlayerFemaleVoice: e.target.value || '',
    }));
  };

  const character_Image = staticAssetImageUrls?.character_Image;
  const full_Images = character_Image?.filter((img: any) => img?.id === 'full');
  const half_Images = character_Image?.filter((img: any) => img?.id === 'half');

  const find_Selected_fullimage =
    full_Images &&
    full_Images?.find((img: any) => img?.name == selectedPlayer?.gasAssetName);
  const selectedImages =
  full_Images?.filter((img: any) =>
    selectedCharacter.some(
      (char) => char.gasAssetName === img.name
    )
  ) || [];
  const find_Selected_halfimage =
    half_Images &&
    half_Images?.find((img: any) => img?.name == selectedPlayer?.gasAssetName);

  const handleNarrator: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    setFormData((prev: any) => ({
      ...prev,
      gameNarratorVoice: e.target.value || '',
    }));
  };

  const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    setFormData((prev: any) => ({
      ...prev,
      gameNonPlayerName: e.target.value || '',
    }));
  };
  const find = show.find((it: any) => it.gasId === formData.gameBackgroundId);
  const img = find?.gasAssetImage;
  //////////////////////////////////////////////////////////////////////////////
  const [showModal, setShowModal] = useState(false);
  const [chosenModal, setChosenModal] = useState('');
  const [chosenVoiceNPC, setChosenVoiceNPC] = useState('');
  const [chosenVoiceMALE, setChosenVoiceMALE] = useState('');
  const [chosenVoiceFEMALE, setChosenVoiceFEMALE] = useState('');
  const [chosenVoicementorMALE, setChosenVoicementorMALE] = useState('');
  const [chosenVoicementorFEMALE, setChosenVoicementorFEMALE] = useState('');
  const [chosenVoiceNAR, setChosenVoiceNAR] = useState('');
  const [activeNpcId, setActiveNpcId] = useState<string | null>(null);

  const handleAddVoice = (character: any ,gasId?: string) => {
    setChosenModal(character);
     if (gasId) {
      setActiveNpcId(gasId); // 👈 track NPC
    }
    setShowModal(true); // Show the modal when the button is clicked

    //alert(chosenModal);
  };
  const closeModal = () => {
    setShowModal(false); // Function to close the modal
    setChosenModal('');
  };

  const audioRef = useRef(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [demo, setDemo] = useState(null);
  const handleInputChange = (inputValue: any) => {
    setSearchTerm(inputValue);
  };

  let currentAudio: any = null;
  const playAudio = (audioUrl: string): Promise<void> => {
    return new Promise<void>((resolve) => {
      if (currentAudio) {
        currentAudio.pause();
        currentAudio.removeEventListener('ended', resolve);
      }

      const audio = new Audio(audioUrl);

      audio.addEventListener('ended', () => {
        resolve();
      });

      audio.play();
      currentAudio = audio;
    });
  };
  const customFilter = (option: any, rawInput: any) => {
    const inputValue = rawInput.toLowerCase();
    const label = option.label.toLowerCase();

    if (label.includes(inputValue)) {
      return true;
    }
    if (option.data && option.data.subcategories) {
      const subcategoryMatch = option.data.subcategories.some(
        (subcategory: any) => subcategory.toLowerCase().includes(inputValue),
      );
      return subcategoryMatch;
    }
    return false;
  };
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const handleMenuOpen = () => {
    setMenuIsOpen(true);
  };

  const handleMenuClose = () => {
    setMenuIsOpen(false);
  };
  const [menuMaleIsOpen, setMenuMaleIsOpen] = useState(false);

  const handleMaleMenuOpen = () => {
    setMenuMaleIsOpen(true);
  };
  const [nonplayerName, setNonplayerName] = useState<String>();

  const handleMaleMenuClose = () => {
    setMenuMaleIsOpen(false);
  };
  const [menufeMaleIsOpen, setMenufeMaleIsOpen] = useState(false);

  const handlefeMaleMenuOpen = () => {
    setMenufeMaleIsOpen(true);
  };

  const handlefeMaleMenuClose = () => {
    setMenufeMaleIsOpen(false);
  };
  const [menuNarateIsOpen, setMenuNarateIsOpen] = useState(false);

  const handleNarateMenuOpen = () => {
    setMenuNarateIsOpen(true);
  };

  const handleNarateeMenuClose = () => {
    setMenuNarateIsOpen(false);
  };
  const options = voices.map((it: any, ind: number) => {
    const { age, accent, gender, ...remainingLabels } = it.labels;
    const subcategories = Object.values(remainingLabels);
    return {
      label: it.name,
      value: it.voice_id,
      subcategories: subcategories,
      audio: it.preview_url,
      index: ind,
      age: age,
      accent: accent,
      gender: gender,
    };
  });
  const maleOptions = voices
    .filter((it: any) => it.labels.gender === 'male')
    .map((it: any, ind: number) => {
      const { gender, ...remainingLabels } = it.labels;
      const subcategories = Object.values(remainingLabels);
      return {
        label: it.name,
        value: it.voice_id,
        subcategories: subcategories,
        audio: it.preview_url,
        index: ind,
      };
    });
  const femaleOptions = voices
    .filter((it: any) => it.labels.gender === 'female')
    .map((it: any, ind: number) => {
      const { gender, ...remainingLabels } = it.labels;
      const subcategories = Object.values(remainingLabels);
      return {
        label: it.name,
        value: it.voice_id,
        subcategories: subcategories,
        audio: it.preview_url,
        index: ind,
      };
    });
  const narrationOptions = voices
    .filter((it: any) => it.labels['use case'] === 'narration')
    .map((it: any, ind: number) => {
      const { 'use case': useCase, ...remainingLabels } = it.labels;
      const subcategories = Object.values(remainingLabels);
      return {
        label: it.name,
        value: it.voice_id,
        subcategories: subcategories,
        audio: it.preview_url,
        index: ind,
      };
    });
const handleNPCSelectChange = (voice: any, chosenModal: string) => {
  setShowModal(false); // Function to close the modal
  setChosenModal('');
  setFormData((prev: any) => {
    const updatedNPCs = gameNonPlayerOption?.map((npc: any) => {
      if (npc.gasId !== activeNpcId) return npc;

      return {
        ...npc,
        voices: {
          ...npc.voices,
          npc: chosenModal === 'NPC' ? voice.value : npc.voices.npc,
          male: chosenModal === 'MALE' ? voice.value : npc.voices.male,
          female: chosenModal === 'FEMALE' ? voice.value : npc.voices.female,
          narrator:
            chosenModal === 'NARRATOR'
              ? voice.value
              : npc.voices.narrator,
        },
      };
    });
 console.log("updatedNPCs",updatedNPCs)
    return {
      ...prev,
      gameNonPlayerOption: updatedNPCs,
    };
  });

  setShowModal(false);
};
console.log("gameNonPlayerOption",gameNonPlayerOption)
console.log("gameNonPlayerOption-formData",formData)
  const handleSelectChange = (selectedOption: any, type: string) => {
    console.log("selectedOption",selectedOption,"type",type)
    setDemo(selectedOption?.audio);
    if (type === 'NPC') {
      handleNPCSelectChange(selectedOption, type);
      return;
    } else if (type === 'MALE') {
      setFormData((prev: any) => ({
        ...prev,
        gamePlayerMaleVoice: selectedOption.value,
      }));
      setShowModal(false); // Function to close the modal
      setChosenModal('');
      setChosenVoiceMALE(selectedOption.label);
    } else if (type === 'FEMALE') {
      setFormData((prev: any) => ({
        ...prev,
        gamePlayerFemaleVoice: selectedOption.value,
      }));
      setShowModal(false); // Function to close the modal
      setChosenModal('');
      setChosenVoiceFEMALE(selectedOption.label);
    } else if (type === 'MENTORMALE') {
      setFormData((prev: any) => ({
        ...prev,
        gamementorMaleVoice: selectedOption.value,
      }));
      setShowModal(false); // Function to close the modal
      setChosenModal('');
      setChosenVoicementorMALE(selectedOption.label);
    } else if (type === 'MENTORFEMALE') {
      setFormData((prev: any) => ({
        ...prev,
        gamementorFemaleVoice: selectedOption.value,
      }));
      setShowModal(false); // Function to close the modal
      setChosenModal('');
      setChosenVoicementorFEMALE(selectedOption.label);
    } else {
      if (type === 'NARRATOR') {
        setFormData((prev: any) => ({
          ...prev,
          gameNarratorVoice: selectedOption.value,
        }));
        setShowModal(false); // Function to close the modal
        setChosenModal('');
        setChosenVoiceNAR(selectedOption.label);
      }
    }
  };
  const [selectedVoice, setSelectedVoice] = useState(null); // To keep track of the selected voice
  const [isPlaying, setIsPlaying] = useState(false);
  const handleClick = async (e: any, data: any) => {
    setIsPlaying(true);
    setSelectedVoice(data);
    try {
      await playAudio(data.audio);
      setIsPlaying(false);
    } catch (error) {
      console.error('Error playing audio: ', error);
      setIsPlaying(false); // Ensure isPlaying is set to false in case of an error
    }
  };
  const colors = ['#e0e7ff', '#f3e8ff'];

  const [selectedFilters, setSelectedFilters] = useState([]); // To keep track of selected filters

  const uniqueSubcategories = [
    ...new Set(options.map((voice: any) => voice.subcategories[1])),
  ];
  const uniquegender = [...new Set(options.map((voice: any) => voice.gender))];
  const uniqueaccent = [...new Set(options.map((voice: any) => voice.accent))];
  const uniqueage = [...new Set(options.map((voice: any) => voice.age))];
  const handleFilterClick = (subcategory: any) => {
    const isSubcategorySelected = selectedFilters.includes(subcategory);

    const updatedFilters = isSubcategorySelected
      ? selectedFilters.filter((filter) => filter !== subcategory)
      : [...selectedFilters, subcategory];

    // Update the selectedFilters state with the updated array
    setSelectedFilters(updatedFilters);
  };
  const filteredSubcategories = uniqueSubcategories.filter(
    (subcategory) => subcategory !== undefined,
  );
  const filteredgender = uniquegender.filter(
    (subcategory) => subcategory !== undefined,
  );
  const filteredaccent = uniqueaccent.filter(
    (subcategory) => subcategory !== undefined,
  );
  const filteredage = uniqueage.filter(
    (subcategory) => subcategory !== undefined,
  );
  const [genderOptions, setGenderOptions] = useState(
    filteredgender.map((option) => ({ label: option, value: option })),
  );
  const [accentOptions, setAccentOptions] = useState(
    filteredaccent.map((option) => ({ label: option, value: option })),
  );

  const [ageOptions, setAgeOptions] = useState(
    filteredage.map((option) => ({ label: option, value: option })),
  );

  const [searchText, setSearchText] = useState('');
  const [selectedGender, setSelectedGender] = useState('');
  const [selectedAccent, setSelectedAccent] = useState('');
  const [selectedAge, setSelectedAge] = useState('');
  const [isHighlighted, setIsHighlighted] = useState(false);

  const handleInputFocus = () => {
    setIsHighlighted(true);
    setBorderHighlighted(false);
  };

  const handleInputBlur = () => {
    setIsHighlighted(false);
    setBorderHighlighted(false);
  };

  var filteredVoices = options.filter((voice: any) => {
    const matchesDescription = voice.label
      .toLowerCase()
      .includes(searchText.toLowerCase());

    const matchesGender =
      selectedGender === '' || voice.gender === selectedGender;

    // Filter based on accent
    const matchesAccent =
      selectedAccent === '' || voice.accent === selectedAccent;

    const matchesSubcategories =
      selectedFilters.length === 0 ||
      voice.subcategories.some((subcategorySet: any) =>
        selectedFilters.some((filter) => subcategorySet.includes(filter)),
      );

    // Filter based on age
    const matchesAge = selectedAge === '' || voice.age === selectedAge;

    return (
      matchesDescription &&
      matchesSubcategories &&
      matchesGender &&
      matchesAccent &&
      matchesAge
    );
  });

  const filterByVoiceId = (voiceIdToFilter: any) => {
    console.log("voiceId reveived",voiceIdToFilter)
    const filteredVoices = options.filter(
      (voice: any) => voice.value === voiceIdToFilter,
    );
    // Replace 'voice_2' with the desired voiceId
    let lbl;
    // Output the label(s) from the filtered result
    filteredVoices.forEach((voice: any) => {
      lbl = voice.label; // Prints the label(s) of the filtered voice(s)
    });
    return lbl;
  };
  const [bgColors, setBgColors] = useState<string[]>(
    Array(filteredVoices.length).fill('transparent'),
  );

  const [borderColors, setBorderColors] = useState<string[]>(
    Array(filteredVoices.length).fill('1px solid #cacfd8'),
  );

  const [isSecondGridVisible, setIsSecondGridVisible] = useState(false);
  const [isBorderHighlighted, setBorderHighlighted] = useState(false);
  const toggleSecondGrid = () => {
    setIsSecondGridVisible(!isSecondGridVisible);
    setBorderHighlighted(true);
  };

  const handleGenderChange = (selectedOption: any) => {
    setSelectedGender(selectedOption ? selectedOption.value : '');
  };

  const handleAccentChange = (selectedOption: any) => {
    setSelectedAccent(selectedOption ? selectedOption.value : '');
  };

  const handleAgeChange = (selectedOption: any) => {
    setSelectedAge(selectedOption ? selectedOption.value : '');
  };

  // Event handler for search input change
  const handleSearchInputChange = (e: any) => {
    setSearchText(e.target.value);
  };
  
  const handleClearFilters = () => {
    setSearchText('');
    setSelectedGender('');
    setSelectedAccent('');
    setSelectedAge('');
    setSelectedFilters([]);
    filteredVoices = voices.map((it: any, ind: number) => {
      const { age, accent, gender, ...remainingLabels } = it.labels;
      const subcategories = Object.values(remainingLabels);
      return {
        label: it.name,
        value: it.voice_id,
        subcategories: subcategories,
        audio: it.preview_url,
        index: ind,
        age: age,
        accent: accent,
        gender: gender,
      };
    });
  };
const getNpcVoice = (gasId: number) => {

const nonPlayerOptions = Array.isArray(formData?.gameNonPlayerOption)
  ? formData.gameNonPlayerOption
  : [];
console.log("nonPlayerOptions",nonPlayerOptions)
  return (
    nonPlayerOptions.find(
      (item: any) => item.gasId === gasId
    )?.voices?.npc || ""
  );
};

  

  const [showLeftButton, setShowLeftButton] = useState(false);

  const [showcount, setShowcount] = useState<any>('');

  const handleLeft = () => {
    const container = document.getElementById('scroll');
    if (container) {
      container.scrollLeft -= 200;

      if (container.scrollLeft <= 0) {
        setShowLeftButton(false);
      }
    }
  };

  const handleRight = () => {
    const container = document.getElementById('scroll');

    if (container) {
      container.scrollLeft += 200;
      setShowcount(container.scrollLeft + 300);
      if (container.scrollLeft > 0) {
        setShowLeftButton(true);
      }
    }
  };
  const capitalizeFirstLetter = (e: any) => {
    return e ? e.charAt(0).toUpperCase() + e.slice(1) : '';
  };
  return (
    <>
      <Modal isOpen={setPreview} onClose={setPreview} size="full">
        <ModalOverlay />
        <ModalContent
          position="fixed"
          overflowY="auto"
          m={0}
          className={'model_class'}
          containerProps={{ zIndex: 999999 }}
        >
          <ModalBody p={'0 20px'}>
            <Flex
              flexDirection={{
                base: 'column',
                sm: 'column',
                md: 'column',
                lg: 'column',
              }}
              justifyContent={{
                base: 'start',
                sm: 'start',
                md: 'start',
                lg: 'start',
              }}
              alignItems={{
                base: 'center',
                sm: 'center',
                md: 'center',
                lg: 'start',
              }}
              height="80vh"
              padding={'20px 0'}
              background="#ffffff"
            >
              <Box width={'100%'} display={'flex'} justifyContent={'end'}>
                <ModalCloseButton position={'relative'} top={0} />
              </Box>
              <Box
                display={'flex'}
                w={'100%'}
                flexDir={{
                  base: 'column',
                  sm: 'column',
                  md: 'column',
                  lg: 'row',
                }}
              >
                {formData.gameNonPlayingCharacterId !== previewId ? (
                  <Card
                    w={{ base: '100%', sm: '100%', md: '100%', lg: '70%' }}
                    mb={{ base: '0px', sm: '0px', lg: '20px' }}
                    h={{ base: '40vh', sm: '40vh', md: '40vh', lg: '90vh' }}
                    backgroundImage={img}
                    backgroundSize={'cover'}
                    backgroundPosition={'center'}
                    backgroundRepeat={'no-repeat'}
                    alignItems={'end'}
                    justifyContent={'flex-end'}
                  >
                    <Img
                      src={find_Selected_fullimage?.src}
                      width={'31%'}
                      height={'78%'}
                      marginRight={'11%'}
                    />
                  </Card>
                ) : prev ? (
                  <Card
                    w={{ base: '100%', sm: '100%', md: '100%', lg: '70%' }}
                    mb={{ base: '0px', sm: '0px', lg: '20px' }}
                    h={{ base: '40vh', sm: '40vh', md: '40vh', lg: '90vh' }}
                    backgroundImage={img}
                    backgroundSize={'cover'}
                    backgroundPosition={'center'}
                    backgroundRepeat={'no-repeat'}
                    alignItems={'end'}
                    justifyContent={'flex-end'}
                  >
                    {/* <Img
                      src={find_Selected_fullimage?.src}
                      width={'31%'}
                      height={
                        [
                          'Nova, the Customer',
                          'Lena, the Team Leader',
                          'Evelina, the Artisan',
                          'Olivia, the Manager',
                        ].includes(selectedPlayer?.gasAssetName)
                          ? '78%'
                          : '78%'
                      }
                      marginRight={'11%'}
                    /> */}
                      {selectedImages.map((image: any, index: number) => (
                        <Img
                        src={image.src}
                          width={'31%'}
                          height={
                            [
                              'Nova, the Customer',
                              'Lena, the Team Leader',
                              'Evelina, the Artisan',
                              'Olivia, the Manager',
                            ].includes(image.name)
                              ? '78%'
                              : '78%'
                          }
                        key={image.name}
                          marginRight={index === 0 ? '11%' : '2%'}
                        />
                      ))}
                  </Card>
                ) : (
                  <Box flex="1" p={4} w={'80%'}>
                    <Image
                      src={find_Selected_fullimage?.src}
                      alt="Your Image"
                      maxH="675px"
                      mb="4"
                    />
                  </Box>
                )}
                {formData.gameNonPlayingCharacterId !== previewId ? (
                  <Card
                    flex="1"
                    w={{ base: '100%', sm: '100%', md: '100%', lg: '30%' }}
                    h={'max-content'}
                    m={{
                      base: '20px 0 20px 0',
                      sm: '20px 0 20px 0',
                      lg: '0 0 20px 20px',
                    }}
                    p={4}
                    boxShadow={'5px 5px 20px #c5c5c5'}
                  >
                    <Flex direction="column" mb="20px" mt="0px">
                      <Text
                        fontSize={'1.25rem'}
                        color={'#1B2559'}
                        fontWeight={'700'}
                      >
                        Non Playing Character
                      </Text>
                      <Text
                        fontSize={'1rem'}
                        style={{ whiteSpace: 'pre-wrap' }}
                      >
                        {selectedPlayer?.gasAssetName
                          ? capitalizeFirstLetter(selectedPlayer.gasAssetName)
                          : ''}
                      </Text>
                    </Flex>{' '}
                    <Button
                      bg="#3311db"
                      _hover={{ bg: '#3311db' }}
                      color="#fff"
                      w="100%"
                      onClick={() =>
                        makeInputFiled(previewId, selectedPlayer?.gasAssetName)
                      }
                    >
                      Select
                    </Button>
                  </Card>
                ) : (
                  <Card
                    flex="1"
                    w={{ base: '100%', sm: '100%', md: '100%', lg: '30%' }}
                    h={'max-content'}
                    m={{
                      base: '20px 0 20px 0',
                      sm: '20px 0 20px 0',
                      lg: '0 0 20px 20px',
                    }}
                    p={4}
                    boxShadow={'5px 5px 20px #c5c5c5'}
                  >
                    <Flex direction="column" mb="20px" mt="0px">
                      <Text
                        fontSize="xl"
                        ml="1px"
                        color={textColorPrimary}
                        fontWeight="bold"
                      >
                        Edit Name
                      </Text>
                    </Flex>
                    <select
                        id="title"
                        name="gameNonPlayerName"
                        onChange={handlePlayerChange}
                        style={{
                          width: '100%',
                          padding: '8px',
                          borderRadius: '4px',
                          border: '1px solid #ccc',
                        }}
                      >
                        <option value="">Select Non-Player Name</option>
                        {players?.map((player: any) => (
                          <option key={player.gasId} value={player.gasId}>
                            {capitalizeFirstLetter(player.gasAssetName)}
                          </option>
                        ))}
                      </select>

                   <div style={{ marginTop: '10px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {selectedCharacter.map((char) => (
                      <div
                        key={char.gasId}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          background: '#edf2f7',
                          padding: '4px 8px',
                          borderRadius: '16px',
                        }}
                      >
                        {/* <span>{capitalizeFirstLetter(char.gasAssetName || char.name)}</span> */}
                        <span> {capitalizeFirstLetter(
    getCharacterDisplayName(char, players)
  )}</span>
                        <button
                          type="button"
                          onClick={() => handleRemovePlayer(char.gasId)}
                          style={{
                            marginLeft: '6px',
                            cursor: 'pointer',
                            border: 'none',
                            background: 'transparent',
                            fontWeight: 'bold',
                          }}
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>


                  {selectedCharacter.map((char) => {
                    const npcVoice = getNpcVoice(char.gasId);

const npcVoiceValue =
  npcVoice && filterByVoiceId(npcVoice)
    ? filterByVoiceId(npcVoice)
    :  "";
                    // console.log("condition-now",formData?.gameNonPlayerOption?.find((item: any) => item.gasId === char.gasId)?.voices?.npc !== ''
                    //                   ? filterByVoiceId(formData?.gameNonPlayerOption?.find((item: any) => item.gasId === char.gasId)?.voices?.npc)
                    //                   : chosenVoiceNPC);
                    //                   console.log("condition-now-formData?.gameNonPlayerOption",formData?.gameNonPlayerOption,"char.gasId",char.gasId,)
                    return(
                      <>
                        <FormControl mb="5px">
                          <InputField
                            id="title"
                            placeholder="eg. Oliver"
                            isRequired={true}
                            label="Non-Player Name"
                            name="gameTitle"
                            // value={capitalizeFirstLetter(formData?.gameNonPlayerOption?.find((item: any) => item.gasId === char.gasId)?.name || '')}
                            value={capitalizeFirstLetter(getCharacterDisplayName(char, players))}
                            readOnly="readOnly"
                            // value={formData?.gameNonPlayerName}
                            // onChange={(
                            //   e: React.ChangeEvent<
                            //     HTMLSelectElement | HTMLInputElement
                            //   >,
                            // ) => {
                            //   handleChange(
                            //     e as React.ChangeEvent<HTMLSelectElement>,
                            //   );
                            // }}
                            w="100%"
                            mb="0px"
                          />
                        </FormControl>
                        <Flex direction="column" mb="20px" mt="10px">
                          <Text
                            fontSize="xl"
                            color={textColorPrimary}
                            fontWeight="bold"
                          >
                            Select Voices
                          </Text>
                          <Text ml="1px" fontSize="md" color={textColorSecondary}>
                            The voices selected for the characters will play only
                            after the game has been created entirely.
                          </Text>
                        </Flex>

                        <FormControl mb="5px">
                          <>
                            <SimpleGrid
                              columns={{ sm: 8, md: 8, xl: 8 }}
                              w="100%"
                              mb="0px"
                              mt="0px"
                            >
                              <Box
                                gridColumn={{
                                  sm: 'span 7',
                                  md: 'span 7',
                                  xl: 'span 7',
                                }}
                                mb="-10px"
                                alignItems="center"
                                mr="0px"
                              >
                                <InputField
                                  id="title"
                                  isRequired={true}
                                  name="Non-PlayerVoice"
                                  readOnly="readOnly"
                                  w="100%"
                                  label="Non-Player Voice"
                                  value={
                                    gameNonPlayerOption?.find((item: any) => item.gasId === char.gasId)?.voices?.npc !== ''
                                      ? filterByVoiceId(gameNonPlayerOption?.find((item: any) => item.gasId === char.gasId)?.voices?.npc)
                                      : chosenVoiceNPC
                                  }
                                  
                                  
                                // value={npcVoiceValue}

                                  borderColor={
                                    gameNonPlayerOption?.find((item: any) => item.gasId === char.gasId)?.voices?.npc === '' ||
                                    gameNonPlayerOption?.find((item: any) => item.gasId === char.gasId)?.voices?.npc === null
                                      ? 'red'
                                      : null
                                  }
                                  // m="0px"
                                />
                              </Box>
                              <Box
                                gridColumn={{
                                  sm: 'span 1',
                                  xl: 'span 1',
                                  md: 'span 1',
                                }}
                                pt="29px"
                                ml="0px"
                                mb="5px"
                                justifyContent="center"
                                alignItems="center"
                              >
                                <div
                                  style={customStylesBtn}
                                  onClick={() => handleAddVoice('NPC',char.gasId)}
                                >
                                  <MdOutlineAdd
                                    size={20}
                                    color={iconColor}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                  />
                                </div>
                              </Box>
                            </SimpleGrid>

                            <Modal
                              isOpen={showModal}
                              onClose={closeModal}
                              size="full"
                            >
                              <ModalOverlay />
                              <ModalContent containerProps={{ zIndex: 999999 }}>
                                <ModalBody>
                                  <>
                                    <Box
                                      style={{
                                        position: 'sticky',
                                        top: '0',
                                        background: 'white',
                                        zIndex: 1000,
                                      }}
                                    >
                                      <ModalHeader></ModalHeader>
                                      <ModalCloseButton />
                                      <SimpleGrid
                                        columns={{ sm: 1, md: 1, xl: 16 }}
                                        w="100%"
                                        border={'1px solid grey'}
                                        alignItems="center"
                                        style={{
                                          position: 'sticky',
                                          top: '0',
                                          background: 'white',
                                          zIndex: 1000,
                                        }}
                                      >
                                        <Box
                                          gridColumn={{
                                            sm: 'span 16',
                                            md: 'span 4',
                                            xl: 'span 4',
                                          }}
                                          mr="0px"
                                          border={`2px solid ${
                                            isHighlighted ? 'grey' : 'lightgrey'
                                          }`}
                                          borderRadius="4px"
                                          bg={
                                            isHighlighted
                                              ? 'transparent'
                                              : 'transparent'
                                          }
                                          display={'flex'}
                                          alignItems={'center'}
                                        >
                                          <InputField
                                            mt={'17px'}
                                            mb={{
                                              base: '10px',
                                              sm: '10px',
                                              md: '30px',
                                            }}
                                            bg="transparent"
                                            placeholder="Search Voices..."
                                            margin="0px"
                                            border="none"
                                            p="20px"
                                            fontSize="0.875rem"
                                            onFocus={handleInputFocus}
                                            onBlur={handleInputBlur}
                                            onChange={(e: any) =>
                                              handleSearchInputChange(e)
                                            }
                                          />
                                        </Box>

                                        <Box
                                          p="10px"
                                          gridColumn={{
                                            sm: 'span 15',
                                            md: 'span 11',
                                            xl: 'span 11',
                                          }}
                                          display="flex"
                                          flexDirection="column"
                                        >
                                          <Box
                                            display="flex"
                                            alignItems="center"
                                            flexWrap="nowrap"
                                            overflowX="hidden"
                                            mr="0px"
                                            id={'scroll'}
                                          >
                                            {filteredSubcategories.map(
                                              (subcategory: any, index: any) => (
                                                <Text
                                                  key={index}
                                                  fontSize="sm"
                                                  display="flex"
                                                  flexWrap="nowrap"
                                                  fontWeight="700"
                                                  float={'left'}
                                                  whiteSpace="pre"
                                                  border={'1px solid #11047a'}
                                                  borderRadius={'10px'}
                                                  color={
                                                    selectedFilters.includes(
                                                      subcategory,
                                                    )
                                                      ? 'white'
                                                      : 'black'
                                                  }
                                                  bg={
                                                    selectedFilters.includes(
                                                      subcategory,
                                                    )
                                                      ? '#11047a'
                                                      : 'transparent'
                                                  }
                                                  onClick={() =>
                                                    handleFilterClick(subcategory)
                                                  }
                                                  style={{
                                                    cursor: 'pointer',
                                                    marginRight: '10px',
                                                    marginBottom: '5px',
                                                    padding: '8px',
                                                  }}
                                                >
                                                  {subcategory}
                                                </Text>
                                              ),
                                            )}
                                          </Box>
                                          <Box
                                            display={'flex'}
                                            justifyContent={'space-between'}
                                            alignItems="flex-end"
                                          >
                                            <Icon
                                              as={FaChevronLeft}
                                              style={{
                                                fontSize: '10px',
                                                cursor: 'pointer',
                                                marginBottom: '5px',
                                                display: 'block',
                                              }}
                                              onClick={handleLeft}
                                            />
                                            <Icon
                                              as={FaChevronRight}
                                              style={{
                                                fontSize: '10px',
                                                cursor: 'pointer',
                                                marginTop: '5px',
                                                display: 'block',
                                              }}
                                              onClick={handleRight}
                                            />
                                          </Box>
                                        </Box>
                                        <Box
                                          p="30px"
                                          gridColumn={{
                                            sm: 'span 1',
                                            md: 'span 1',
                                            xl: 'span 1',
                                          }}
                                          onClick={toggleSecondGrid}
                                          display="flex"
                                          alignItems="center"
                                          border={`2px solid ${
                                            isBorderHighlighted
                                              ? 'grey'
                                              : 'lightgrey'
                                          }`}
                                          flexWrap="nowrap"
                                          overflowX="scroll"
                                          mr="0px"
                                        >
                                          {isSecondGridVisible ? (
                                            <Icon
                                              as={FaWindowClose}
                                              style={customStylesicon}
                                            />
                                          ) : (
                                            <Icon
                                              as={FaSlidersH}
                                              style={customStylesicon}
                                            />
                                          )}
                                        </Box>
                                      </SimpleGrid>

                                      {isSecondGridVisible && (
                                        <motion.div
                                          initial={{
                                            opacity: 0,
                                            height: 0,
                                            transform: 'translateY(-50px)',
                                          }}
                                          animate={{
                                            opacity: isSecondGridVisible ? 1 : 0.5,
                                            height: isSecondGridVisible
                                              ? '100%'
                                              : 0,
                                            transform: isSecondGridVisible
                                              ? 'translateY(0px)'
                                              : 'translateY(-50px)',
                                          }}
                                          transition={{
                                            duration: 0.3,
                                            ease: 'easeInOut',
                                          }}
                                          className="voice-library-filters"
                                          style={{
                                            // overflow: "hidden",
                                            border: '1px solid grey',
                                            background: '#ececec',
                                            gridColumn: 'span 16', // Adjust this to your grid layout
                                            width: '100%',
                                            alignItems: 'center',
                                            display: 'flex', // Add this line

                                            position: 'sticky',
                                            top: '11%',
                                            zIndex: 999,
                                            borderTop: 'none',
                                          }}
                                        >
                                          <Box
                                            pl={{ base: '0', sm: '0', lg: '20px' }}
                                            pr={{ base: '0', sm: '0', lg: '150px' }}
                                            gridColumn={{
                                              sm: 'span 16',
                                              md: 'span 4',
                                              xl: 'span 4',
                                            }}
                                            alignItems="center"
                                          >
                                            <Box
                                              style={{
                                                margin: '0',
                                                paddingTop: '20px',
                                                paddingBottom: '20px',
                                              }}
                                            >
                                              <Text
                                                fontSize="13px"
                                                color={textColorPrimary}
                                              >
                                                ADVANCED FILTERS
                                              </Text>
                                            </Box>
                                          </Box>

                                          <Box
                                            p="10px"
                                            gridColumn={{
                                              sm: 'span 14',
                                              md: 'span 10',
                                              xl: 'span 10',
                                            }}
                                            display="flex"
                                            flexDir={{
                                              base: 'column',
                                              sm: 'column',
                                              lg: 'row',
                                            }}
                                            alignItems="center"
                                            mr="0px"
                                            position="relative"
                                          >
                                            <Box
                                              position={{
                                                base: 'unset',
                                                sm: 'unset',
                                                lg: 'absolute',
                                              }}
                                              mr={{ base: '0', sm: 0, lg: '20px' }}
                                              style={{
                                                left: '-130px',
                                                width: '150px',
                                                zIndex: '500',
                                              }}
                                            >
                                              <Select
                                                placeholder="Gender"
                                                options={genderOptions}
                                                // styles={customStyles}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 999999,
                                                  }),
                                                  option: (
                                                    provided: any,
                                                    state: any,
                                                  ) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused
                                                      ? '#e0e0e0'
                                                      : 'transparent',
                                                    cursor: 'pointer',
                                                    color: 'black',
                                                    zIndex: '101',
                                                    '&:hover': {
                                                      backgroundColor: '#e0e0e0', // Change background color on hover
                                                    },
                                                  }),
                                                }}
                                                value={
                                                  // Conditionally set the value based on some condition
                                                  selectedGender !== ''
                                                    ? genderOptions.find(
                                                        (option) =>
                                                          option.value ===
                                                          selectedGender,
                                                      )
                                                    : ''
                                                }
                                                onChange={handleGenderChange}
                                              />
                                            </Box>
                                            <Box
                                              position={{
                                                base: 'unset',
                                                sm: 'unset',
                                                lg: 'absolute',
                                              }}
                                              mr={{ base: '0', sm: 0, lg: '20px' }}
                                              style={{
                                                left: '50px',
                                                width: '150px',
                                                zIndex: '500',
                                              }}
                                            >
                                              {/* Render other dropdowns similarly */}
                                              <Select
                                                placeholder="Accent"
                                                options={accentOptions}
                                                // styles={customStyles}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 999999,
                                                  }),
                                                  option: (
                                                    provided: any,
                                                    state: any,
                                                  ) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused
                                                      ? '#e0e0e0'
                                                      : 'transparent',
                                                    cursor: 'pointer',
                                                    color: 'black',
                                                    zIndex: '101',
                                                    '&:hover': {
                                                      backgroundColor: '#e0e0e0', // Change background color on hover
                                                    },
                                                  }),
                                                }}
                                                value={
                                                  selectedAccent !== ''
                                                    ? accentOptions.find(
                                                        (option) =>
                                                          option.value ===
                                                          selectedAccent,
                                                      )
                                                    : ''
                                                }
                                                onChange={handleAccentChange}
                                              />
                                            </Box>{' '}
                                            <Box
                                              position={{
                                                base: 'unset',
                                                sm: 'unset',
                                                lg: 'absolute',
                                              }}
                                              mr={{ base: '0', sm: 0, lg: '20px' }}
                                              style={{
                                                left: '230px',
                                                width: '150px',
                                                zIndex: '500',
                                              }}
                                            >
                                              <Select
                                                placeholder="Age"
                                                options={ageOptions}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 999999,
                                                  }),
                                                  option: (
                                                    provided: any,
                                                    state: any,
                                                  ) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused
                                                      ? '#e0e0e0'
                                                      : 'transparent',
                                                    cursor: 'pointer',
                                                    color: 'black',
                                                    zIndex: '101',
                                                    '&:hover': {
                                                      backgroundColor: '#e0e0e0',
                                                    },
                                                  }),
                                                }}
                                                value={
                                                  selectedAge !== ''
                                                    ? ageOptions.find(
                                                        (option) =>
                                                          option.value ===
                                                          selectedAge,
                                                      )
                                                    : ''
                                                }
                                                onChange={handleAgeChange}
                                              />{' '}
                                            </Box>
                                          </Box>
                                          <Box
                                            p="5px"
                                            gridColumn={{
                                              sm: 'span 2',
                                              md: 'span 2',
                                              xl: 'span 2',
                                            }}
                                            display="flex"
                                            alignItems="center"
                                            mr="0px"
                                          >
                                            <Button
                                              variant="light"
                                              fontSize="sm"
                                              borderRadius="16px"
                                              position={{
                                                base: 'unset',
                                                sm: 'unset',
                                                lg: 'absolute',
                                              }}
                                              zIndex="500"
                                              right="-60px"
                                              h="46px"
                                              m={{ base: '0', sm: '0', lg: '80px' }}
                                              onClick={handleClearFilters}
                                            >
                                              Clear All
                                            </Button>
                                          </Box>
                                        </motion.div>
                                      )}
                                    </Box>
                                  </>

                                  <Box w={'100%'} mt="20px" p="20px">
                                    <>
                                      <Flex direction="column" mb="20px" mt="0px">
                                        <Text
                                          fontSize="34px"
                                          color={textColorPrimary}
                                          fontWeight="700"
                                        >
                                          Voice Library
                                        </Text>
                                        <Text
                                          fontSize="md"
                                          color={textColorSecondary}
                                        >
                                          Here you can discover voices
                                        </Text>
                                      </Flex>
                                      <SimpleGrid
                                        columns={{ sm: 1, md: 2, xl: 4 }}
                                        spacing={{ base: '20px', xl: '20px' }}
                                      >
                                        {filteredVoices.map(
                                          (voice: any, index: number) => {
                                            let bg = 'transparent';
                                            let bg2 = 'transparent';
                                            let border = '1px solid #cacfd8';

                                            if (chosenModal === 'NPC') {
                                              bg =
                                                gameNonPlayerOption?.find((item: any) => item.gasId === char.gasId)?.voices?.npc ===
                                                voice.value
                                                  ? boxBg
                                                  : bgColors[index];
                                              bg2 =
                                                gameNonPlayerOption?.find((item: any) => item.gasId === char.gasId)?.voices?.npc ===
                                                voice.value
                                                  ? '#11047a'
                                                  : 'transparent';
                                              border =
                                                gameNonPlayerOption?.find((item: any) => item.gasId === char.gasId)?.voices?.npc ===
                                                voice.value
                                                  ? '2px solid #11047a'
                                                  : borderColors[index];
                                            } 
                                           else if (chosenModal === 'MALE') {
                                          bg =
                                            formData.gamePlayerMaleVoice ===
                                            voice.value
                                              ? boxBg
                                              : bgColors[index];
                                          bg2 =
                                            formData.gamePlayerMaleVoice ===
                                            voice.value
                                              ? '#11047a'
                                              : 'transparent';
                                          border =
                                            formData.gamePlayerMaleVoice ===
                                            voice.value
                                              ? '2px solid #11047a'
                                              : borderColors[index];
                                        } else if (chosenModal === 'FEMALE') {
                                          bg =
                                            formData.gamePlayerFemaleVoice ===
                                            voice.value
                                              ? boxBg
                                              : bgColors[index];
                                          bg2 =
                                            formData.gamePlayerFemaleVoice ===
                                            voice.value
                                              ? '#11047a'
                                              : 'transparent';
                                          border =
                                            formData.gamePlayerFemaleVoice ===
                                            voice.value
                                              ? '2px solid #11047a'
                                              : borderColors[index];
                                        } else if (chosenModal === 'NARRATOR') {
                                          bg =
                                            formData.gameNarratorVoice ===
                                            voice.value
                                              ? boxBg
                                              : bgColors[index];
                                          bg2 =
                                            formData.gameNarratorVoice ===
                                            voice.value
                                              ? '#11047a'
                                              : 'transparent';
                                          border =
                                            formData.gameNarratorVoice ===
                                            voice.value
                                              ? '2px solid #11047a'
                                              : borderColors[index];
                                        }
                                            const isVoiceSelected =
                                              (chosenModal === 'NPC' &&
                                                gameNonPlayerOption?.find((item: any) => item.gasId === char.gasId)?.voices?.npc ===
                                                  voice.value) ||
          
                                                   (chosenModal === 'MALE' &&
                                            formData.gamePlayerMaleVoice ===
                                              voice.value) ||
                                          (chosenModal === 'FEMALE' &&
                                            formData.gamePlayerFemaleVoice ===
                                              voice.value) ||
                                          (chosenModal === 'NARRATOR' &&
                                            formData.gameNarratorVoice ===
                                              voice.value);

                                            return (
                                              <Flex
                                                key={voice.value}
                                                direction="column"
                                                bg={bg}
                                                mb="38px"
                                                className="flex-item"
                                                borderRadius={'10px'}
                                                border={border}
                                                position="relative"
                                                boxShadow="0px 4px 12px rgba(0, 0, 0, 0.1)"
                                              >
                                                <Box
                                                  p="16px 20px"
                                                  lineHeight={'1.25rem'}
                                                >
                                                  {isVoiceSelected && (
                                                    <Flex
                                                      position="absolute"
                                                      top="-10px"
                                                      right="-10px"
                                                      width="20px"
                                                      height="20px"
                                                      borderRadius="50%"
                                                      bg={bg2}
                                                      alignItems="center"
                                                      justifyContent="center"
                                                      zIndex="1"
                                                      overflow="hidden"
                                                    >
                                                      <Icon
                                                        as={MdOutlineCheck}
                                                        w="15px"
                                                        h="15px"
                                                        color="white"
                                                      />
                                                    </Flex>
                                                  )}
                                                  <Text
                                                    fontSize="sm"
                                                    fontWeight="700"
                                                    color={'black'}
                                                  >
                                                    {voice.label}
                                                  </Text>
                                                  <Text
                                                    fontSize="sm"
                                                    fontWeight="500"
                                                    color={'black'}
                                                    textTransform={'capitalize'}
                                                  >
                                                    {voice.age} {voice.accent}{' '}
                                                    {voice.gender}
                                                  </Text>
                                                  <Box
                                                    style={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    <Box
                                                      style={{ display: 'flex' }}
                                                      fontSize={'14px'}
                                                    >
                                                      {voice.subcategories &&
                                                        voice.subcategories.length >
                                                          0 && (
                                                          <Box
                                                            style={{
                                                              display: 'flex',
                                                              marginRight: '12px',
                                                              gap: '.25rem',
                                                            }}
                                                          >
                                                            {voice.subcategories.map(
                                                              (
                                                                subcategory: any,
                                                                index: number,
                                                              ) => (
                                                                <Box
                                                                  key={index}
                                                                  style={{
                                                                    borderRadius:
                                                                      '20px',
                                                                    whiteSpace:
                                                                      'nowrap',
                                                                    fontSize:
                                                                      '0.775rem',
                                                                    fontWeight:
                                                                      '400',
                                                                    paddingRight:
                                                                      '6px',
                                                                    paddingLeft:
                                                                      '6px',
                                                                    backgroundColor:
                                                                      colors[index],
                                                                    marginRight:
                                                                      '4px',
                                                                  }}
                                                                >
                                                                  {subcategory}
                                                                </Box>
                                                              ),
                                                            )}
                                                          </Box>
                                                        )}
                                                    </Box>
                                                  </Box>
                                                </Box>

                                                <div
                                                  style={{
                                                    borderTop: '1px solid #cacfd8',
                                                    marginTop: '10px',
                                                    width: '100%',
                                                    float: 'left', // Pushes buttons to the bottom
                                                  }}
                                                >
                                                  <Button
                                                    bg={'transparent'}
                                                    w={'50%'}
                                                    borderRadius={'0px'}
                                                    p={'0px'}
                                                    fontSize={'0.875rem'}
                                                    fontWeight={'600'}
                                                    borderRight={
                                                      '1px solid #cacfd8'
                                                    }
                                                    onClick={(e) =>
                                                      handleClick(e, voice)
                                                    }
                                                    disabled={
                                                      isPlaying ? true : false
                                                    }
                                                  >
                                                    <Box
                                                      style={{
                                                        marginLeft: '4px',
                                                        marginRight: '12px',
                                                      }}
                                                      h={'100%'}
                                                      display={'flex'}
                                                      alignItems={'center'}
                                                    >
                                                      {isPlaying &&
                                                      selectedVoice.value ==
                                                        voice.value ? (
                                                        <Spinner />
                                                      ) : (
                                                        <>
                                                          {' '}
                                                          <Icon
                                                            as={FaVolumeUp}
                                                            style={customStylesicon}
                                                          />{' '}
                                                          <span
                                                            style={customStylesicon}
                                                          >
                                                            Sample
                                                          </span>
                                                        </>
                                                      )}
                                                    </Box>
                                                  </Button>

                                                  <Button
                                                    w={'50%'}
                                                    p={'0px'}
                                                    bg={'transparent'}
                                                    fontSize={'0.875rem'}
                                                    fontWeight={'600'}
                                                    borderRadius={'0px'}
                                                    onClick={() =>
                                                      handleSelectChange(
                                                        voice,
                                                        chosenModal,
                                                      )
                                                    }
                                                  >
                                                    <>
                                                      {' '}
                                                      <Icon
                                                        as={FaPlusCircle}
                                                        style={customStylesicon}
                                                      />{' '}
                                                      <span
                                                        style={customStylesicon}
                                                      >
                                                        Add to Character
                                                      </span>
                                                    </>
                                                  </Button>
                                                </div>
                                              </Flex>
                                            );
                                          },
                                        )}
                                      </SimpleGrid>
                                      {filteredVoices.length === 0 && (
                                        <Box p="20px" textAlign="center">
                                          <Text fontSize="7vw" color="#858c9757">
                                            No Voice Found
                                          </Text>
                                        </Box>
                                      )}

                                      {filteredVoices.map(
                                        (voice: any, index: number) => (
                                          <div key={index}></div>
                                        ),
                                      )}
                                    </>
                                  </Box>
                                </ModalBody>
                              </ModalContent>
                            </Modal>
                          </>
                        </FormControl>

                      
                      </>
                  )})}
                   <FormControl mb="-5px">
                      <SimpleGrid columns={{ sm: 8, md: 8, xl: 8 }} w="100%">
                        <Box
                          gridColumn={{
                            sm: 'span 7',
                            md: 'span 7',
                            xl: 'span 7',
                          }}
                          alignItems="center"
                          mr="0px"
                        >
                          <InputField
                            id="male"
                            isRequired={true}
                            name="PlayerMaleVoice"
                            readOnly="readOnly"
                            w="100%"
                            label="Player Male Voice"
                            borderColor={
                              formData.gamePlayerMaleVoice === '' ||
                              formData.gamePlayerMaleVoice === null
                                ? 'red'
                                : null
                            }
                            value={
                              formData.gamePlayerMaleVoice !== ''
                                ? filterByVoiceId(formData.gamePlayerMaleVoice)
                                : chosenVoiceMALE
                            }
                            m="0px"
                          />
                        </Box>
                        <Box
                          gridColumn={{
                            sm: 'span 1',
                            xl: 'span 1',
                            md: 'span 1',
                          }}
                          pt="29px"
                          ml="0px"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <div
                            style={customStylesBtn}
                            onClick={() => handleAddVoice('MALE')}
                          >
                            <MdOutlineAdd
                              size={20}
                              color={iconColor}
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                            />
                          </div>
                        </Box>
                      </SimpleGrid>
                    </FormControl>
                    <FormControl mb="-5px">
                      <SimpleGrid
                        columns={{ sm: 8, md: 8, xl: 8 }}
                        w="100%"
                        mt="0px"
                      >
                        <Box
                          gridColumn={{
                            sm: 'span 7',
                            md: 'span 7',
                            xl: 'span 7',
                          }}
                          alignItems="center"
                          mr="0px"
                        >
                          <InputField
                            id="female"
                            isRequired={true}
                            name="PlayerFemaleVoice"
                            readOnly="readOnly"
                            w="100%"
                            label="Player Female Voice"
                            borderColor={
                              formData.gamePlayerFemaleVoice === '' ||
                              formData.gamePlayerFemaleVoice === null
                                ? 'red'
                                : null
                            }
                            value={
                              formData.gamePlayerFemaleVoice !== ''
                                ? filterByVoiceId(
                                    formData.gamePlayerFemaleVoice,
                                  )
                                : chosenVoiceFEMALE
                            }
                            m="0px"
                          />
                        </Box>
                        <Box
                          gridColumn={{
                            sm: 'span 1',
                            xl: 'span 1',
                            md: 'span 1',
                          }}
                          pt="29px"
                          ml="0px"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <div
                            style={customStylesBtn}
                            onClick={() => handleAddVoice('FEMALE')}
                          >
                            <MdOutlineAdd
                              size={20}
                              color={iconColor}
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                            />
                          </div>
                        </Box>
                      </SimpleGrid>
                    </FormControl>
  <FormControl mb="-5px">
                      <SimpleGrid columns={{ sm: 8, md: 8, xl: 8 }} w="100%">
                        <Box
                          gridColumn={{
                            sm: 'span 7',
                            md: 'span 7',
                            xl: 'span 7',
                          }}
                          alignItems="center"
                          mr="0px"
                        >
                          <InputField
                            id="mentormale"
                            isRequired={true}
                            name="MentorMaleVoice"
                            readOnly="readOnly"
                            w="100%"
                            label="Mentor Male Voice"
                            borderColor={
                              formData.gamementorMaleVoice === '' ||
                              formData.gamementorMaleVoice === null
                                ? 'red'
                                : null
                            }
                            value={
                              formData.gamementorMaleVoice !== ''
                                ? filterByVoiceId(formData.gamementorMaleVoice)
                                : chosenVoicementorMALE
                            }
                            m="0px"
                          />
                        </Box>
                        <Box
                          gridColumn={{
                            sm: 'span 1',
                            xl: 'span 1',
                            md: 'span 1',
                          }}
                          pt="29px"
                          ml="0px"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <div
                            style={customStylesBtn}
                            onClick={() => handleAddVoice('MENTORMALE')}
                          >
                            <MdOutlineAdd
                              size={20}
                              color={iconColor}
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                            />
                          </div>
                        </Box>
                      </SimpleGrid>
                    </FormControl>
                    <FormControl mb="-5px">
                      <SimpleGrid
                        columns={{ sm: 8, md: 8, xl: 8 }}
                        w="100%"
                        mt="0px"
                      >
                        <Box
                          gridColumn={{
                            sm: 'span 7',
                            md: 'span 7',
                            xl: 'span 7',
                          }}
                          alignItems="center"
                          mr="0px"
                        >
                          <InputField
                            id="mentorfemale"
                            isRequired={true}
                            name="mentorFemaleVoice"
                            readOnly="readOnly"
                            w="100%"
                            label="Mentor Female Voice"
                            borderColor={
                              formData.gamementorFemaleVoice === '' ||
                              formData.gamementorFemaleVoice === null
                                ? 'red'
                                : null
                            }
                            value={
                              formData.gamementorFemaleVoice !== ''
                                ? filterByVoiceId(
                                    formData.gamementorFemaleVoice,
                                  )
                                : chosenVoicementorFEMALE
                            }
                            m="0px"
                          />
                        </Box>
                        <Box
                          gridColumn={{
                            sm: 'span 1',
                            xl: 'span 1',
                            md: 'span 1',
                          }}
                          pt="29px"
                          ml="0px"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <div
                            style={customStylesBtn}
                            onClick={() => handleAddVoice('MENTORFEMALE')}
                          >
                            <MdOutlineAdd
                              size={20}
                              color={iconColor}
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                            />
                          </div>
                        </Box>
                      </SimpleGrid>
                    </FormControl>
                    <FormControl mb="-5px">
                      <SimpleGrid columns={{ sm: 8, md: 8, xl: 8 }} w="100%">
                        <Box
                          gridColumn={{
                            sm: 'span 7',
                            md: 'span 7',
                            xl: 'span 7',
                          }}
                          alignItems="center"
                          mr="0px"
                        >
                          <InputField
                            id="narrator"
                            isRequired={true}
                            name="NarratorVoice"
                            readOnly="readOnly"
                            w="100%"
                            label="Narrator Voice"
                            borderColor={
                              formData.gameNarratorVoice === '' ||
                              formData.gameNarratorVoice === null
                                ? 'red'
                                : null
                            }
                            value={
                              formData.gameNarratorVoice !== ''
                                ? filterByVoiceId(formData.gameNarratorVoice)
                                : chosenVoiceNAR
                            }
                            m="0px"
                          />
                        </Box>
                        <Box
                          gridColumn={{
                            sm: 'span 1',
                            xl: 'span 1',
                            md: 'span 1',
                          }}
                          pt="29px"
                          ml="0px"
                          mb="5px"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <div
                            style={customStylesBtn}
                            onClick={() => handleAddVoice('NARRATOR')}
                          >
                            <MdOutlineAdd
                              size={20}
                              color={iconColor}
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                            />
                          </div>
                        </Box>
                      </SimpleGrid>
                    </FormControl>
                    <Button
                      bg="#3311db"
                      _hover={{ bg: '#3311db' }}
                      color="#fff"
                      w="100%"
                      onClick={commonNextFunction}
                    >
                      Submit
                    </Button>
                  </Card>
                )}
              </Box>
            </Flex>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CharacterPreview;





